/* tslint:disable */
/* auto-generated angular directive proxies */
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, EventEmitter, NgZone } from '@angular/core';

import { ProxyCmp, proxyOutputs } from './angular-component-lib/utils';

import { Components } from '@liebherr/patternlib';


@ProxyCmp({
  inputs: ['allowToExpandAll', 'keepOpenOnDesktop', 'type']
})
@Component({
  selector: 'patternlib-accordion',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['allowToExpandAll', 'keepOpenOnDesktop', 'type'],
})
export class PatternlibAccordion {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
    proxyOutputs(this, this.el, ['lhChange']);
  }
}


import type { LhChange as IPatternlibAccordionLhChange } from '@liebherr/patternlib';

export declare interface PatternlibAccordion extends Components.PatternlibAccordion {
  /**
   * Emitted each time an accordion-item is closed or opened.
Contains a list of indicies of all open items, starting with index 0 for the first item.
   */
  lhChange: EventEmitter<CustomEvent<IPatternlibAccordionLhChange>>;
}


@ProxyCmp({
  inputs: ['isFirst', 'isLast', 'isOpen', 'keepOpenOnDesktop', 'label', 'type'],
  methods: ['closePanel', 'setAdjacent']
})
@Component({
  selector: 'patternlib-accordion-item',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['isFirst', 'isLast', 'isOpen', 'keepOpenOnDesktop', 'label', 'type'],
})
export class PatternlibAccordionItem {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
    proxyOutputs(this, this.el, ['lhAccordionItemToggle']);
  }
}


import type { lhAccordionItemToggle as IPatternlibAccordionItemlhAccordionItemToggle } from '@liebherr/patternlib';

export declare interface PatternlibAccordionItem extends Components.PatternlibAccordionItem {

  lhAccordionItemToggle: EventEmitter<CustomEvent<IPatternlibAccordionItemlhAccordionItemToggle>>;
}


@ProxyCmp({
  inputs: ['iconName', 'type']
})
@Component({
  selector: 'patternlib-alert-message',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['iconName', 'type'],
})
export class PatternlibAlertMessage {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


export declare interface PatternlibAlertMessage extends Components.PatternlibAlertMessage {}


@ProxyCmp({
  inputs: ['color', 'iconName', 'label', 'width']
})
@Component({
  selector: 'patternlib-app',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['color', 'iconName', 'label', 'width'],
})
export class PatternlibApp {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


export declare interface PatternlibApp extends Components.PatternlibApp {}


@ProxyCmp({
  inputs: ['actionLabel', 'appsTotalCount', 'flyoutPosition', 'height', 'label', 'show', 'useFlyoutGroups'],
  methods: ['closeFlyout']
})
@Component({
  selector: 'patternlib-applauncher',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['actionLabel', 'appsTotalCount', 'flyoutPosition', 'height', 'label', 'show', 'useFlyoutGroups'],
})
export class PatternlibApplauncher {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
    proxyOutputs(this, this.el, ['lhActionClick', 'lhScroll']);
  }
}


import type { LhActionClick as IPatternlibApplauncherLhActionClick } from '@liebherr/patternlib';

export declare interface PatternlibApplauncher extends Components.PatternlibApplauncher {
  /**
   * Provide a method to be triggered if the action is clicked.
   */
  lhActionClick: EventEmitter<CustomEvent<IPatternlibApplauncherLhActionClick>>;
  /**
   * Emittet if the flyout-items container is scrolled.
   */
  lhScroll: EventEmitter<CustomEvent<any>>;
}


@ProxyCmp({
  inputs: ['accessToken', 'baseUrl', 'environment', 'flyoutPosition', 'httpErrorCode', 'show']
})
@Component({
  selector: 'patternlib-applauncher-service',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['accessToken', 'baseUrl', 'environment', 'flyoutPosition', 'httpErrorCode', 'show'],
})
export class PatternlibApplauncherService {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


export declare interface PatternlibApplauncherService extends Components.PatternlibApplauncherService {}


@ProxyCmp({
  inputs: ['backgroundTransparent', 'iconSize', 'initials', 'loggedOut', 'noStates', 'sizeSmall', 'variant']
})
@Component({
  selector: 'patternlib-avatar',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['backgroundTransparent', 'iconSize', 'initials', 'loggedOut', 'noStates', 'sizeSmall', 'variant'],
})
export class PatternlibAvatar {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


export declare interface PatternlibAvatar extends Components.PatternlibAvatar {}


@ProxyCmp({
  inputs: ['badgeBorder', 'badgeSize', 'badgeSmall', 'color', 'iconName', 'iconSize', 'noStates', 'offsetBottom', 'topPosition', 'value']
})
@Component({
  selector: 'patternlib-badge',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['badgeBorder', 'badgeSize', 'badgeSmall', 'color', 'iconName', 'iconSize', 'noStates', 'offsetBottom', 'topPosition', 'value'],
})
export class PatternlibBadge {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


export declare interface PatternlibBadge extends Components.PatternlibBadge {}


@ProxyCmp({
  inputs: ['barPercentage', 'data', 'dataLabelFontSize', 'headlineFontSize', 'labelDirection', 'labelFontSize', 'legendPosition', 'showDataLabels', 'showLegend', 'showTooltips', 'subheadlineFontSize', 'unit']
})
@Component({
  selector: 'patternlib-bar-chart',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['barPercentage', 'data', 'dataLabelFontSize', 'headlineFontSize', 'labelDirection', 'labelFontSize', 'legendPosition', 'showDataLabels', 'showLegend', 'showTooltips', 'subheadlineFontSize', 'unit'],
})
export class PatternlibBarChart {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


export declare interface PatternlibBarChart extends Components.PatternlibBarChart {}


@ProxyCmp({
})
@Component({
  selector: 'patternlib-breadcrumb',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: [],
})
export class PatternlibBreadcrumb {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


export declare interface PatternlibBreadcrumb extends Components.PatternlibBreadcrumb {}


@ProxyCmp({
  inputs: ['arrowBack', 'show'],
  methods: ['update']
})
@Component({
  selector: 'patternlib-breadcrumb-item',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['arrowBack', 'show'],
})
export class PatternlibBreadcrumbItem {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


export declare interface PatternlibBreadcrumbItem extends Components.PatternlibBreadcrumbItem {}


@ProxyCmp({
})
@Component({
  selector: 'patternlib-breadcrumb-website',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: [],
})
export class PatternlibBreadcrumbWebsite {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


export declare interface PatternlibBreadcrumbWebsite extends Components.PatternlibBreadcrumbWebsite {}


@ProxyCmp({
  inputs: ['hideArrow', 'iconName', 'iconSize', 'isVisible']
})
@Component({
  selector: 'patternlib-breadcrumb-website-item',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['hideArrow', 'iconName', 'iconSize', 'isVisible'],
})
export class PatternlibBreadcrumbWebsiteItem {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


export declare interface PatternlibBreadcrumbWebsiteItem extends Components.PatternlibBreadcrumbWebsiteItem {}


@ProxyCmp({
  inputs: ['disabled', 'display', 'iconPosition', 'label', 'loading', 'noStates', 'size', 'type', 'width']
})
@Component({
  selector: 'patternlib-button',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['disabled', 'display', 'iconPosition', 'label', 'loading', 'noStates', 'size', 'type', 'width'],
})
export class PatternlibButton {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


export declare interface PatternlibButton extends Components.PatternlibButton {}


@ProxyCmp({
  inputs: ['height', 'minHeight', 'noBorder', 'noStates', 'type', 'width']
})
@Component({
  selector: 'patternlib-card',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['height', 'minHeight', 'noBorder', 'noStates', 'type', 'width'],
})
export class PatternlibCard {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


export declare interface PatternlibCard extends Components.PatternlibCard {}


@ProxyCmp({
  inputs: ['arrowPosition', 'autoSlidingInterval', 'currentPageIndex', 'description', 'headline', 'height', 'showArrows', 'type', 'width']
})
@Component({
  selector: 'patternlib-carousel',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['arrowPosition', 'autoSlidingInterval', 'currentPageIndex', 'description', 'headline', 'height', 'showArrows', 'type', 'width'],
})
export class PatternlibCarousel {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


export declare interface PatternlibCarousel extends Components.PatternlibCarousel {}


@ProxyCmp({
})
@Component({
  selector: 'patternlib-carousel-item',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: [],
})
export class PatternlibCarouselItem {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


export declare interface PatternlibCarouselItem extends Components.PatternlibCarouselItem {}


@ProxyCmp({
  inputs: ['controlled', 'disabled', 'focused', 'hidden', 'label', 'selected', 'size', 'value']
})
@Component({
  selector: 'patternlib-check-option',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['controlled', 'disabled', 'focused', 'hidden', 'label', 'selected', 'size', 'value'],
})
export class PatternlibCheckOption {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
    proxyOutputs(this, this.el, ['lhOptionSelect']);
  }
}


import type { LhInternalOptionSelect as IPatternlibCheckOptionLhInternalOptionSelect } from '@liebherr/patternlib';

export declare interface PatternlibCheckOption extends Components.PatternlibCheckOption {
  /**
   * Emits an LhOptionSelect on click.
   */
  lhOptionSelect: EventEmitter<CustomEvent<IPatternlibCheckOptionLhInternalOptionSelect>>;
}


@ProxyCmp({
  inputs: ['checked', 'controlled', 'disabled', 'extendedTouchArea', 'indeterminate', 'label', 'name', 'status', 'width'],
  methods: ['setFocus', 'setBlur']
})
@Component({
  selector: 'patternlib-checkbox',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['checked', 'controlled', 'disabled', 'extendedTouchArea', 'indeterminate', 'label', 'name', 'status', 'width'],
})
export class PatternlibCheckbox {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
    proxyOutputs(this, this.el, ['lhChange']);
  }
}


import type { LhChange as IPatternlibCheckboxLhChange } from '@liebherr/patternlib';

export declare interface PatternlibCheckbox extends Components.PatternlibCheckbox {
  /**
   * Provide a method to be triggered each time the checkbox is clicked.
   */
  lhChange: EventEmitter<CustomEvent<IPatternlibCheckboxLhChange>>;
}


@ProxyCmp({
  inputs: ['acceptButtonText', 'backgroundColor', 'backgroundImageOverlayColor', 'checkboxText', 'consent', 'consentHeaderText', 'height', 'iconName', 'iconSet', 'variant', 'width'],
  methods: ['setScreenSize']
})
@Component({
  selector: 'patternlib-consent',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['acceptButtonText', 'backgroundColor', 'backgroundImageOverlayColor', 'checkboxText', 'consent', 'consentHeaderText', 'height', 'iconName', 'iconSet', 'variant', 'width'],
})
export class PatternlibConsent {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
    proxyOutputs(this, this.el, ['lhAccept']);
  }
}


import type { lhAccept as IPatternlibConsentlhAccept } from '@liebherr/patternlib';

export declare interface PatternlibConsent extends Components.PatternlibConsent {
  /**
   * Provide a method to be triggered when the accept-button is clicked
   */
  lhAccept: EventEmitter<CustomEvent<IPatternlibConsentlhAccept>>;
}


@ProxyCmp({
  inputs: ['description', 'name']
})
@Component({
  selector: 'patternlib-contact',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['description', 'name'],
})
export class PatternlibContact {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


export declare interface PatternlibContact extends Components.PatternlibContact {}


@ProxyCmp({
  inputs: ['bold', 'condensed', 'icon', 'label', 'linkUnderline', 'type', 'uppercase', 'value']
})
@Component({
  selector: 'patternlib-contact-item',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['bold', 'condensed', 'icon', 'label', 'linkUnderline', 'type', 'uppercase', 'value'],
})
export class PatternlibContactItem {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


export declare interface PatternlibContactItem extends Components.PatternlibContactItem {}


@ProxyCmp({
  inputs: ['disabled', 'size', 'type', 'variant']
})
@Component({
  selector: 'patternlib-control-element',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['disabled', 'size', 'type', 'variant'],
})
export class PatternlibControlElement {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


export declare interface PatternlibControlElement extends Components.PatternlibControlElement {}


@ProxyCmp({
  inputs: ['contentHeight', 'height', 'minHeight', 'width']
})
@Component({
  selector: 'patternlib-dashboard-card',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['contentHeight', 'height', 'minHeight', 'width'],
})
export class PatternlibDashboardCard {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


export declare interface PatternlibDashboardCard extends Components.PatternlibDashboardCard {}


@ProxyCmp({
  inputs: ['cardTitle']
})
@Component({
  selector: 'patternlib-dashboard-card-contentcard',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['cardTitle'],
})
export class PatternlibDashboardCardContentcard {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


export declare interface PatternlibDashboardCardContentcard extends Components.PatternlibDashboardCardContentcard {}


@ProxyCmp({
  inputs: ['headerSubline', 'headerTitle', 'image']
})
@Component({
  selector: 'patternlib-dashboard-card-contentheader',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['headerSubline', 'headerTitle', 'image'],
})
export class PatternlibDashboardCardContentheader {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


export declare interface PatternlibDashboardCardContentheader extends Components.PatternlibDashboardCardContentheader {}


@ProxyCmp({
})
@Component({
  selector: 'patternlib-dashboard-card-footer',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: [],
})
export class PatternlibDashboardCardFooter {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


export declare interface PatternlibDashboardCardFooter extends Components.PatternlibDashboardCardFooter {}


@ProxyCmp({
})
@Component({
  selector: 'patternlib-dashboard-card-header',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: [],
})
export class PatternlibDashboardCardHeader {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


export declare interface PatternlibDashboardCardHeader extends Components.PatternlibDashboardCardHeader {}


@ProxyCmp({
  inputs: ['additionalInfo', 'applyButtonText', 'cancelButtonText', 'controlled', 'date', 'dateParser', 'dateRange', 'dateTimeFormat', 'disableManualInput', 'disabled', 'display', 'errorText', 'firstDayOfWeek', 'format', 'fromDateText', 'fullDayText', 'hideButtonsOnDesktop', 'infoText', 'label', 'locale', 'maximumDate', 'minimumDate', 'name', 'placeholder', 'showRemoveIcon', 'showTimeEditor', 'size', 'status', 'submitOnBlur', 'successText', 'timeStep', 'toDateText', 'todayButtonText', 'usePlaceholderHeight', 'weekdays', 'width'],
  methods: ['resetDatepicker', 'suggestDate', 'setScreenSize']
})
@Component({
  selector: 'patternlib-datepicker',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['additionalInfo', 'applyButtonText', 'cancelButtonText', 'controlled', 'date', 'dateParser', 'dateRange', 'dateTimeFormat', 'disableManualInput', 'disabled', 'display', 'errorText', 'firstDayOfWeek', 'format', 'fromDateText', 'fullDayText', 'hideButtonsOnDesktop', 'infoText', 'label', 'locale', 'maximumDate', 'minimumDate', 'name', 'placeholder', 'showRemoveIcon', 'showTimeEditor', 'size', 'status', 'submitOnBlur', 'successText', 'timeStep', 'toDateText', 'todayButtonText', 'usePlaceholderHeight', 'weekdays', 'width'],
})
export class PatternlibDatepicker {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
    proxyOutputs(this, this.el, ['lhChange', 'lhCancel', 'lhDateSelection']);
  }
}


import type { LhChange as IPatternlibDatepickerLhChange } from '@liebherr/patternlib';

export declare interface PatternlibDatepicker extends Components.PatternlibDatepicker {
  /**
   * Provide a method to get triggered each time the value has changed
   */
  lhChange: EventEmitter<CustomEvent<IPatternlibDatepickerLhChange>>;
  /**
   * Emitted if the cancel button is clicked.
   */
  lhCancel: EventEmitter<CustomEvent<void>>;
  /**
   * Emitted when the user selects a date manually.
Useful when a date range was previously set from an external source (like presets)
and this external state needs to be resettet because the user chose to select a date manually.
   */
  lhDateSelection: EventEmitter<CustomEvent<void>>;
}


@ProxyCmp({
  inputs: ['additionalInfo', 'dateParser', 'dateRange', 'disabled', 'display', 'errorText', 'format', 'infoText', 'isOpen', 'label', 'locale', 'nativeOnMobile', 'placeholder', 'showRemoveIcon', 'showTimeInLabel', 'size', 'status', 'submitOnBlur', 'successText', 'useManualInput', 'usePlaceholderHeight', 'value', 'warningText', 'width']
})
@Component({
  selector: 'patternlib-datepicker-input',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['additionalInfo', 'dateParser', 'dateRange', 'disabled', 'display', 'errorText', 'format', 'infoText', 'isOpen', 'label', 'locale', 'nativeOnMobile', 'placeholder', 'showRemoveIcon', 'showTimeInLabel', 'size', 'status', 'submitOnBlur', 'successText', 'useManualInput', 'usePlaceholderHeight', 'value', 'warningText', 'width'],
})
export class PatternlibDatepickerInput {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
    proxyOutputs(this, this.el, ['lhClearDatepicker', '__lhInternalDatepickerDateSelected', 'lhCloseDatepicker']);
  }
}


import type { LhClearDatepicker as IPatternlibDatepickerInputLhClearDatepicker } from '@liebherr/patternlib';
import type { LhDateSelected as IPatternlibDatepickerInputLhDateSelected } from '@liebherr/patternlib';

export declare interface PatternlibDatepickerInput extends Components.PatternlibDatepickerInput {
  /**
   * Provide a method to be triggered each time the close icon get clicked.
   */
  lhClearDatepicker: EventEmitter<CustomEvent<IPatternlibDatepickerInputLhClearDatepicker>>;
  /**
   * Provide a method to get triggered each time a date get selected
   */
  __lhInternalDatepickerDateSelected: EventEmitter<CustomEvent<IPatternlibDatepickerInputLhDateSelected>>;
  /**
   * Provide a method to get triggered each time a date get selected
   */
  lhCloseDatepicker: EventEmitter<CustomEvent<void>>;
}


@ProxyCmp({
  inputs: ['active', 'border', 'cursor', 'date', 'dayOfMonth', 'disabled', 'isToday', 'label']
})
@Component({
  selector: 'patternlib-datepicker-item',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['active', 'border', 'cursor', 'date', 'dayOfMonth', 'disabled', 'isToday', 'label'],
})
export class PatternlibDatepickerItem {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
    proxyOutputs(this, this.el, ['__lhInternalDatepickerDateSelected']);
  }
}


import type { LhDateSelected as IPatternlibDatepickerItemLhDateSelected } from '@liebherr/patternlib';

export declare interface PatternlibDatepickerItem extends Components.PatternlibDatepickerItem {
  /**
   * Provide a method to get triggered each time a date get selected
   */
  __lhInternalDatepickerDateSelected: EventEmitter<CustomEvent<IPatternlibDatepickerItemLhDateSelected>>;
}


@ProxyCmp({
  inputs: ['applyButtonText', 'calendarDate', 'cancelButtonText', 'date', 'dateRange', 'dates', 'format', 'fromDateText', 'fullDayText', 'hideButtonsOnDesktop', 'locale', 'showTimeEditor', 'timeStep', 'toDateText', 'todayButtonText', 'weekdays']
})
@Component({
  selector: 'patternlib-datepicker-view',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['applyButtonText', 'calendarDate', 'cancelButtonText', 'date', 'dateRange', 'dates', 'format', 'fromDateText', 'fullDayText', 'hideButtonsOnDesktop', 'locale', 'showTimeEditor', 'timeStep', 'toDateText', 'todayButtonText', 'weekdays'],
})
export class PatternlibDatepickerView {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


export declare interface PatternlibDatepickerView extends Components.PatternlibDatepickerView {}


@ProxyCmp({
  inputs: ['data', 'label', 'legendPosition', 'showLegend', 'showTooltips', 'unit']
})
@Component({
  selector: 'patternlib-donut-chart',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['data', 'label', 'legendPosition', 'showLegend', 'showTooltips', 'unit'],
})
export class PatternlibDonutChart {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


export declare interface PatternlibDonutChart extends Components.PatternlibDonutChart {}


@ProxyCmp({
  inputs: ['additionalInfo', 'additionalInfoPosition', 'allowCustomValue', 'closeOnScroll', 'controlled', 'disabled', 'display', 'errorText', 'filterable', 'infoText', 'label', 'name', 'placeholder', 'preventInput', 'showArrowIcon', 'showRemoveIcon', 'size', 'status', 'successText', 'usePlaceholderHeight', 'value', 'warningText', 'width'],
  methods: ['setFocus', 'setBlur']
})
@Component({
  selector: 'patternlib-dropdown',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['additionalInfo', 'additionalInfoPosition', 'allowCustomValue', 'closeOnScroll', 'controlled', 'disabled', 'display', 'errorText', 'filterable', 'infoText', 'label', 'name', 'placeholder', 'preventInput', 'showArrowIcon', 'showRemoveIcon', 'size', 'status', 'successText', 'usePlaceholderHeight', 'value', 'warningText', 'width'],
})
export class PatternlibDropdown {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
    proxyOutputs(this, this.el, ['lhSelect', 'lhChange']);
  }
}


import type { LhSingleOptionSelectEvent as IPatternlibDropdownLhSingleOptionSelectEvent } from '@liebherr/patternlib';
import type { LhChange as IPatternlibDropdownLhChange } from '@liebherr/patternlib';

export declare interface PatternlibDropdown extends Components.PatternlibDropdown {
  /**
   * Set the dropdown event for other components to listen to the selected option item
   */
  lhSelect: EventEmitter<CustomEvent<IPatternlibDropdownLhSingleOptionSelectEvent>>;
  /**
   * Provide a method to get triggered each time the input value has changed
   */
  lhChange: EventEmitter<CustomEvent<IPatternlibDropdownLhChange>>;
}


@ProxyCmp({
  inputs: ['closeOnScroll', 'controlled', 'disabled', 'listWidth', 'name', 'noHorizontalPadding', 'placeholder', 'size', 'value', 'width'],
  methods: ['setFocus', 'setBlur']
})
@Component({
  selector: 'patternlib-dropdownsubtle',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['closeOnScroll', 'controlled', 'disabled', 'listWidth', 'name', 'noHorizontalPadding', 'placeholder', 'size', 'value', 'width'],
})
export class PatternlibDropdownsubtle {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
    proxyOutputs(this, this.el, ['lhSelect']);
  }
}


import type { LhSingleOptionSelectEvent as IPatternlibDropdownsubtleLhSingleOptionSelectEvent } from '@liebherr/patternlib';

export declare interface PatternlibDropdownsubtle extends Components.PatternlibDropdownsubtle {
  /**
   * Set the dropdown event for other components to listen to the selected option item
   */
  lhSelect: EventEmitter<CustomEvent<IPatternlibDropdownsubtleLhSingleOptionSelectEvent>>;
}


@ProxyCmp({
  inputs: ['acceptedFiles', 'action', 'additionalInfo', 'allowAllFiles', 'allowAllFilesizes', 'allowResume', 'dropHereText', 'dropzoneLabel', 'files', 'label', 'language', 'manualFileStatus', 'maxSumFilesizes', 'multiple', 'name', 'newFileText', 'showDefaultSubmitButton', 'status', 'submitButtonLabel', 'width'],
  methods: ['setFileStatus']
})
@Component({
  selector: 'patternlib-dropzone',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['acceptedFiles', 'action', 'additionalInfo', 'allowAllFiles', 'allowAllFilesizes', 'allowResume', 'dropHereText', 'dropzoneLabel', 'files', 'label', 'language', 'manualFileStatus', 'maxSumFilesizes', 'multiple', 'name', 'newFileText', 'showDefaultSubmitButton', 'status', 'submitButtonLabel', 'width'],
})
export class PatternlibDropzone {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
    proxyOutputs(this, this.el, ['lhChange', 'lhDropzoneSubmit', 'lhUploadCancelled', 'lhUploadResumed']);
  }
}


import type { LhChange as IPatternlibDropzoneLhChange } from '@liebherr/patternlib';
import type { LhDropzoneSubmit as IPatternlibDropzoneLhDropzoneSubmit } from '@liebherr/patternlib';

export declare interface PatternlibDropzone extends Components.PatternlibDropzone {
  /**
   * Provide a method to get triggered each time the user adds or removes a file from upload list.
The current userfiles list will be sent as an array: Array<File>.
   */
  lhChange: EventEmitter<CustomEvent<IPatternlibDropzoneLhChange>>;
  /**
   * Provide a method to get triggered each time the user clicks on the submit button.
   */
  lhDropzoneSubmit: EventEmitter<CustomEvent<IPatternlibDropzoneLhDropzoneSubmit>>;
  /**
   * Triggered when the user aborts an ongoing upload. Can contain multiple files, mostly it will only be one.
   */
  lhUploadCancelled: EventEmitter<CustomEvent<IPatternlibDropzoneLhChange>>;
  /**
   * Triggered when the user resumes an stop/cancelled upload. Can contain multiple files, mostly it will only be one.
   */
  lhUploadResumed: EventEmitter<CustomEvent<IPatternlibDropzoneLhChange>>;
}


@ProxyCmp({
  inputs: ['headline', 'size', 'width']
})
@Component({
  selector: 'patternlib-empty-state',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['headline', 'size', 'width'],
})
export class PatternlibEmptyState {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


export declare interface PatternlibEmptyState extends Components.PatternlibEmptyState {}


@ProxyCmp({
  inputs: ['iconName', 'size', 'status']
})
@Component({
  selector: 'patternlib-empty-state-visual',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['iconName', 'size', 'status'],
})
export class PatternlibEmptyStateVisual {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


export declare interface PatternlibEmptyStateVisual extends Components.PatternlibEmptyStateVisual {}


@ProxyCmp({
  inputs: ['type']
})
@Component({
  selector: 'patternlib-energy-label',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['type'],
})
export class PatternlibEnergyLabel {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


export declare interface PatternlibEnergyLabel extends Components.PatternlibEnergyLabel {}


@ProxyCmp({
  inputs: ['flagBorder', 'flagName', 'flagRadius', 'flagWidth', 'rectangle']
})
@Component({
  selector: 'patternlib-flag',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['flagBorder', 'flagName', 'flagRadius', 'flagWidth', 'rectangle'],
})
export class PatternlibFlag {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


export declare interface PatternlibFlag extends Components.PatternlibFlag {}


@ProxyCmp({
  inputs: ['alignContent', 'alignItems', 'backgroundColor', 'flow', 'height', 'inline', 'justifyContent', 'margin', 'minHeight', 'padding', 'width']
})
@Component({
  selector: 'patternlib-flex',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['alignContent', 'alignItems', 'backgroundColor', 'flow', 'height', 'inline', 'justifyContent', 'margin', 'minHeight', 'padding', 'width'],
})
export class PatternlibFlex {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


export declare interface PatternlibFlex extends Components.PatternlibFlex {}


@ProxyCmp({
  inputs: ['alignSelf', 'backgroundColor', 'centerUsingMargins', 'flex', 'height', 'margin', 'maxWidth', 'order', 'padding', 'textAlign', 'width']
})
@Component({
  selector: 'patternlib-flex-item',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['alignSelf', 'backgroundColor', 'centerUsingMargins', 'flex', 'height', 'margin', 'maxWidth', 'order', 'padding', 'textAlign', 'width'],
})
export class PatternlibFlexItem {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


export declare interface PatternlibFlexItem extends Components.PatternlibFlexItem {}


@ProxyCmp({
  inputs: ['defaultAlign', 'flyoutPosition', 'gap', 'groupName', 'hideArrow', 'offset', 'restrictMaxHeight', 'show', 'useFlyoutGroups', 'userInfo', 'userInitials', 'userName', 'width', 'zIndex'],
  methods: ['openFlyoutmenu', 'closeFlyoutmenu']
})
@Component({
  selector: 'patternlib-flyoutmenu',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['defaultAlign', 'flyoutPosition', 'gap', 'groupName', 'hideArrow', 'offset', 'restrictMaxHeight', 'show', 'useFlyoutGroups', 'userInfo', 'userInitials', 'userName', 'width', 'zIndex'],
})
export class PatternlibFlyoutmenu {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
    proxyOutputs(this, this.el, ['lhFlyoutClosed']);
  }
}


import type { LhClose as IPatternlibFlyoutmenuLhClose } from '@liebherr/patternlib';

export declare interface PatternlibFlyoutmenu extends Components.PatternlibFlyoutmenu {
  /**
   * Emits when closeFlyoutmenu() was invoked.
   */
  lhFlyoutClosed: EventEmitter<CustomEvent<IPatternlibFlyoutmenuLhClose>>;
}


@ProxyCmp({
  inputs: ['detail', 'disabled', 'href', 'itemId', 'label', 'overflow', 'target', 'type', 'useNotoFontBold', 'width']
})
@Component({
  selector: 'patternlib-flyoutmenu-item',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['detail', 'disabled', 'href', 'itemId', 'label', 'overflow', 'target', 'type', 'useNotoFontBold', 'width'],
})
export class PatternlibFlyoutmenuItem {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


export declare interface PatternlibFlyoutmenuItem extends Components.PatternlibFlyoutmenuItem {}


@ProxyCmp({
})
@Component({
  selector: 'patternlib-flyoutmenu-separator',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: [],
})
export class PatternlibFlyoutmenuSeparator {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


export declare interface PatternlibFlyoutmenuSeparator extends Components.PatternlibFlyoutmenuSeparator {}


@ProxyCmp({
  inputs: ['additionalLinks', 'links', 'showArrowIcon', 'showLogo'],
  methods: ['setScreenSize']
})
@Component({
  selector: 'patternlib-footer',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['additionalLinks', 'links', 'showArrowIcon', 'showLogo'],
})
export class PatternlibFooter {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
    proxyOutputs(this, this.el, ['lhClickArrowTop', 'lhClickLink', 'lhClickBrandLogo']);
  }
}


import type { LhClickArrowTop as IPatternlibFooterLhClickArrowTop } from '@liebherr/patternlib';
import type { LhClickLink as IPatternlibFooterLhClickLink } from '@liebherr/patternlib';
import type { LhClickBrandLogo as IPatternlibFooterLhClickBrandLogo } from '@liebherr/patternlib';

export declare interface PatternlibFooter extends Components.PatternlibFooter {
  /**
   * Provide a method to be triggered each time the arrow-top icon is clicked.
   */
  lhClickArrowTop: EventEmitter<CustomEvent<IPatternlibFooterLhClickArrowTop>>;
  /**
   * Provide a method to be triggered each time a link is clicked.
   */
  lhClickLink: EventEmitter<CustomEvent<IPatternlibFooterLhClickLink>>;
  /**
   * Provide a method to be triggered each time the brand-logo is clicked.
   */
  lhClickBrandLogo: EventEmitter<CustomEvent<IPatternlibFooterLhClickBrandLogo>>;
}


@ProxyCmp({
  inputs: ['allowToExpandAll', 'footerDefault', 'paddingBottomExtended']
})
@Component({
  selector: 'patternlib-footer-website',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['allowToExpandAll', 'footerDefault', 'paddingBottomExtended'],
})
export class PatternlibFooterWebsite {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


export declare interface PatternlibFooterWebsite extends Components.PatternlibFooterWebsite {}


@ProxyCmp({
  inputs: ['functionalItem'],
  methods: ['closePanel']
})
@Component({
  selector: 'patternlib-footer-website-block',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['functionalItem'],
})
export class PatternlibFooterWebsiteBlock {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
    proxyOutputs(this, this.el, ['lhFooterAccordionOpened']);
  }
}


export declare interface PatternlibFooterWebsiteBlock extends Components.PatternlibFooterWebsiteBlock {

  lhFooterAccordionOpened: EventEmitter<CustomEvent<void>>;
}


@ProxyCmp({
  inputs: ['hideLabelMobile', 'iconName', 'iconSize', 'isIconBold', 'isLanguageChange', 'label']
})
@Component({
  selector: 'patternlib-footer-website-link',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['hideLabelMobile', 'iconName', 'iconSize', 'isIconBold', 'isLanguageChange', 'label'],
})
export class PatternlibFooterWebsiteLink {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


export declare interface PatternlibFooterWebsiteLink extends Components.PatternlibFooterWebsiteLink {}


@ProxyCmp({
  inputs: ['additionalInfoPosition', 'margin', 'status', 'usePlaceholderHeight']
})
@Component({
  selector: 'patternlib-form-group',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['additionalInfoPosition', 'margin', 'status', 'usePlaceholderHeight'],
})
export class PatternlibFormGroup {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


export declare interface PatternlibFormGroup extends Components.PatternlibFormGroup {}


@ProxyCmp({
  inputs: ['outsourced']
})
@Component({
  selector: 'patternlib-formatting-controls',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['outsourced'],
})
export class PatternlibFormattingControls {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


export declare interface PatternlibFormattingControls extends Components.PatternlibFormattingControls {}


@ProxyCmp({
  inputs: ['outsourcable', 'outsourced', 'position']
})
@Component({
  selector: 'patternlib-formatting-controls-divider',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['outsourcable', 'outsourced', 'position'],
})
export class PatternlibFormattingControlsDivider {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


export declare interface PatternlibFormattingControlsDivider extends Components.PatternlibFormattingControlsDivider {}


@ProxyCmp({
  inputs: ['iconName', 'label', 'outsourcable', 'outsourced', 'position', 'size']
})
@Component({
  selector: 'patternlib-formatting-controls-item',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['iconName', 'label', 'outsourcable', 'outsourced', 'position', 'size'],
})
export class PatternlibFormattingControlsItem {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


export declare interface PatternlibFormattingControlsItem extends Components.PatternlibFormattingControlsItem {}


@ProxyCmp({
  inputs: ['activeElementStyle', 'gap', 'iconSize', 'inactiveElementStyle', 'value', 'width'],
  methods: ['next', 'prev']
})
@Component({
  selector: 'patternlib-gallery-carousel',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['activeElementStyle', 'gap', 'iconSize', 'inactiveElementStyle', 'value', 'width'],
})
export class PatternlibGalleryCarousel {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
    proxyOutputs(this, this.el, ['lhGalleryCarouselItemSelected']);
  }
}


import type { lhGalleryCarouselItemSelectedEvent as IPatternlibGalleryCarousellhGalleryCarouselItemSelectedEvent } from '@liebherr/patternlib';

export declare interface PatternlibGalleryCarousel extends Components.PatternlibGalleryCarousel {
  /**
   * This event is fired every time the selected prop of an item changes from false to true. Passes the value
of this element via details
   */
  lhGalleryCarouselItemSelected: EventEmitter<CustomEvent<IPatternlibGalleryCarousellhGalleryCarouselItemSelectedEvent>>;
}


@ProxyCmp({
  inputs: ['disabled', 'selected', 'value']
})
@Component({
  selector: 'patternlib-gallery-carousel-item',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['disabled', 'selected', 'value'],
})
export class PatternlibGalleryCarouselItem {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


export declare interface PatternlibGalleryCarouselItem extends Components.PatternlibGalleryCarouselItem {}


@ProxyCmp({
  inputs: ['alignContent', 'areas', 'backgroundColor', 'columns', 'gap', 'height', 'justifyContent', 'margin', 'padding', 'rows', 'width', 'zIndex']
})
@Component({
  selector: 'patternlib-grid',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['alignContent', 'areas', 'backgroundColor', 'columns', 'gap', 'height', 'justifyContent', 'margin', 'padding', 'rows', 'width', 'zIndex'],
})
export class PatternlibGrid {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


export declare interface PatternlibGrid extends Components.PatternlibGrid {}


@ProxyCmp({
  inputs: ['alignSelf', 'area', 'backgroundColor', 'border', 'height', 'justifySelf', 'margin', 'padding', 'textAlign', 'width', 'zIndex']
})
@Component({
  selector: 'patternlib-grid-item',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['alignSelf', 'area', 'backgroundColor', 'border', 'height', 'justifySelf', 'margin', 'padding', 'textAlign', 'width', 'zIndex'],
})
export class PatternlibGridItem {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


export declare interface PatternlibGridItem extends Components.PatternlibGridItem {}


@ProxyCmp({
  inputs: ['hasBurgerMenu', 'mainNavigationOffset', 'navigationBackdropColor', 'showNavigationBackdrop']
})
@Component({
  selector: 'patternlib-header',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['hasBurgerMenu', 'mainNavigationOffset', 'navigationBackdropColor', 'showNavigationBackdrop'],
})
export class PatternlibHeader {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
    proxyOutputs(this, this.el, ['lhFlyoutNavigationBackdropToggled', 'lhMobileMenuToggled', 'lhHeaderBackdropClicked']);
  }
}


import type { LhFlyoutNavigationBackdropToggled as IPatternlibHeaderLhFlyoutNavigationBackdropToggled } from '@liebherr/patternlib';
import type { LhMobileMenuToggled as IPatternlibHeaderLhMobileMenuToggled } from '@liebherr/patternlib';

export declare interface PatternlibHeader extends Components.PatternlibHeader {
  /**
   * Triggered when the flyout navigation backdrop is toggled. Contains the current state.
   */
  lhFlyoutNavigationBackdropToggled: EventEmitter<CustomEvent<IPatternlibHeaderLhFlyoutNavigationBackdropToggled>>;
  /**
   * Triggered when the mobile menu is toggled. Contains the current state.
   */
  lhMobileMenuToggled: EventEmitter<CustomEvent<IPatternlibHeaderLhMobileMenuToggled>>;

  lhHeaderBackdropClicked: EventEmitter<CustomEvent<void>>;
}


@ProxyCmp({
  inputs: ['brandLogo', 'mobileMenuIsOpen', 'moreSlotWidth', 'navigationBackdropColor', 'padding', 'portalName', 'sticky', 'stickyByDefault', 'unseenNotificationCount', 'usePadding']
})
@Component({
  selector: 'patternlib-header-portal',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['brandLogo', 'mobileMenuIsOpen', 'moreSlotWidth', 'navigationBackdropColor', 'padding', 'portalName', 'sticky', 'stickyByDefault', 'unseenNotificationCount', 'usePadding'],
})
export class PatternlibHeaderPortal {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
    proxyOutputs(this, this.el, ['lhSticky', 'lhTabClick', 'lhMobileSearch', 'lhMobileEnterPress', 'lhClickBrandLogo', 'lhFlyoutNavigationBackdropToggled']);
  }
}


import type { LhSticky as IPatternlibHeaderPortalLhSticky } from '@liebherr/patternlib';
import type { LhChangeItem as IPatternlibHeaderPortalLhChangeItem } from '@liebherr/patternlib';
import type { LhMobileSearch as IPatternlibHeaderPortalLhMobileSearch } from '@liebherr/patternlib';
import type { LhClickBrandLogo as IPatternlibHeaderPortalLhClickBrandLogo } from '@liebherr/patternlib';
import type { LhFlyoutNavigationBackdropToggled as IPatternlibHeaderPortalLhFlyoutNavigationBackdropToggled } from '@liebherr/patternlib';

export declare interface PatternlibHeaderPortal extends Components.PatternlibHeaderPortal {
  /**
   * Provide a method to be triggered if the scrollY is greater than the header's offsetTop.
   */
  lhSticky: EventEmitter<CustomEvent<IPatternlibHeaderPortalLhSticky>>;
  /**
   * Provide a method to be triggered each time a tab is clicked.
   */
  lhTabClick: EventEmitter<CustomEvent<IPatternlibHeaderPortalLhChangeItem>>;
  /**
   * Provide a method to get the searchbox value when the search icon get clicked.
   */
  lhMobileSearch: EventEmitter<CustomEvent<IPatternlibHeaderPortalLhMobileSearch>>;
  /**
   * Provide a method to get the searchbox value when the Enter key get pressed.
   */
  lhMobileEnterPress: EventEmitter<CustomEvent<IPatternlibHeaderPortalLhMobileSearch>>;
  /**
   * Provide a method to be triggered each time the brand-logo is clicked.
   */
  lhClickBrandLogo: EventEmitter<CustomEvent<IPatternlibHeaderPortalLhClickBrandLogo>>;
  /**
   * Triggered when the flyout navigation backdrop is toggled. Contains the current state.
   */
  lhFlyoutNavigationBackdropToggled: EventEmitter<CustomEvent<IPatternlibHeaderPortalLhFlyoutNavigationBackdropToggled>>;
}


@ProxyCmp({
  inputs: ['animation', 'animationDelay', 'color', 'headingTag', 'headline', 'hyphens', 'separator', 'width'],
  methods: ['animateHeadline', 'updateHeadline']
})
@Component({
  selector: 'patternlib-headline',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['animation', 'animationDelay', 'color', 'headingTag', 'headline', 'hyphens', 'separator', 'width'],
})
export class PatternlibHeadline {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


export declare interface PatternlibHeadline extends Components.PatternlibHeadline {}


@ProxyCmp({
  inputs: ['alt', 'animation', 'cardAlign', 'cardWidth', 'center', 'headline', 'headlineColor', 'height', 'hyphens', 'objectFit', 'src', 'text', 'topPosition', 'width'],
  methods: ['animateCard', 'updateHeroImage']
})
@Component({
  selector: 'patternlib-hero-image',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['alt', 'animation', 'cardAlign', 'cardWidth', 'center', 'headline', 'headlineColor', 'height', 'hyphens', 'objectFit', 'src', 'text', 'topPosition', 'width'],
})
export class PatternlibHeroImage {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


export declare interface PatternlibHeroImage extends Components.PatternlibHeroImage {}


@ProxyCmp({
  inputs: ['active', 'border', 'colorTheme', 'disabled', 'size', 'type', 'value']
})
@Component({
  selector: 'patternlib-hotspot-button',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['active', 'border', 'colorTheme', 'disabled', 'size', 'type', 'value'],
})
export class PatternlibHotspotButton {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


export declare interface PatternlibHotspotButton extends Components.PatternlibHotspotButton {}


@ProxyCmp({
  inputs: ['message', 'statusCode']
})
@Component({
  selector: 'patternlib-http-error-frame',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['message', 'statusCode'],
})
export class PatternlibHttpErrorFrame {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


export declare interface PatternlibHttpErrorFrame extends Components.PatternlibHttpErrorFrame {}


@ProxyCmp({
  inputs: ['message', 'statusCode', 'suppressAnimation']
})
@Component({
  selector: 'patternlib-http-error-page',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['message', 'statusCode', 'suppressAnimation'],
})
export class PatternlibHttpErrorPage {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


export declare interface PatternlibHttpErrorPage extends Components.PatternlibHttpErrorPage {}


@ProxyCmp({
  inputs: ['bold', 'color', 'disabled', 'display', 'iconName', 'size', 'variant']
})
@Component({
  selector: 'patternlib-icon',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['bold', 'color', 'disabled', 'display', 'iconName', 'size', 'variant'],
})
export class PatternlibIcon {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


export declare interface PatternlibIcon extends Components.PatternlibIcon {}


@ProxyCmp({
  inputs: ['disabled']
})
@Component({
  selector: 'patternlib-icon-button',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['disabled'],
})
export class PatternlibIconButton {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


export declare interface PatternlibIconButton extends Components.PatternlibIconButton {}


@ProxyCmp({
  inputs: ['bold', 'color', 'disabled', 'display', 'iconName', 'size', 'variant']
})
@Component({
  selector: 'patternlib-icon-svg',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['bold', 'color', 'disabled', 'display', 'iconName', 'size', 'variant'],
})
export class PatternlibIconSvg {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


export declare interface PatternlibIconSvg extends Components.PatternlibIconSvg {}


@ProxyCmp({
  inputs: ['activeCategory', 'favorites', 'hideCategories', 'icons', 'mappings', 'recentlyUsed', 'searchFunc', 'searchInputPlaceholder']
})
@Component({
  selector: 'patternlib-iconpicker',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['activeCategory', 'favorites', 'hideCategories', 'icons', 'mappings', 'recentlyUsed', 'searchFunc', 'searchInputPlaceholder'],
})
export class PatternlibIconpicker {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
    proxyOutputs(this, this.el, ['lhCategorySelect', 'lhIconSelect']);
  }
}


import type { LhIconpickerClick as IPatternlibIconpickerLhIconpickerClick } from '@liebherr/patternlib';

export declare interface PatternlibIconpicker extends Components.PatternlibIconpicker {
  /**
   * Emitted if a category is selected.
   */
  lhCategorySelect: EventEmitter<CustomEvent<string>>;
  /**
   * Emitted if the user selected an icon.
   */
  lhIconSelect: EventEmitter<CustomEvent<IPatternlibIconpickerLhIconpickerClick>>;
}


@ProxyCmp({
  inputs: ['alt', 'height', 'maxWidth', 'objectFit', 'src', 'width']
})
@Component({
  selector: 'patternlib-image',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['alt', 'height', 'maxWidth', 'objectFit', 'src', 'width'],
})
export class PatternlibImage {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


export declare interface PatternlibImage extends Components.PatternlibImage {}


@ProxyCmp({
  inputs: ['animation', 'buttonLabel', 'countryLabel', 'countryText', 'countryTitle', 'languageList', 'languageText', 'languageTitle']
})
@Component({
  selector: 'patternlib-language-change',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['animation', 'buttonLabel', 'countryLabel', 'countryText', 'countryTitle', 'languageList', 'languageText', 'languageTitle'],
})
export class PatternlibLanguageChange {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
    proxyOutputs(this, this.el, ['lhCountryBtnClick']);
  }
}


export declare interface PatternlibLanguageChange extends Components.PatternlibLanguageChange {

  lhCountryBtnClick: EventEmitter<CustomEvent<void>>;
}


@ProxyCmp({
  inputs: ['abbreviation', 'itemId', 'label', 'selected']
})
@Component({
  selector: 'patternlib-language-change-item',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['abbreviation', 'itemId', 'label', 'selected'],
})
export class PatternlibLanguageChangeItem {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


export declare interface PatternlibLanguageChangeItem extends Components.PatternlibLanguageChangeItem {}


@ProxyCmp({
  inputs: ['flyoutPosition', 'options', 'selected', 'show', 'width']
})
@Component({
  selector: 'patternlib-language-picker',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['flyoutPosition', 'options', 'selected', 'show', 'width'],
})
export class PatternlibLanguagePicker {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
    proxyOutputs(this, this.el, ['lhSelect']);
  }
}


import type { LhLanguageSelectEvent as IPatternlibLanguagePickerLhLanguageSelectEvent } from '@liebherr/patternlib';

export declare interface PatternlibLanguagePicker extends Components.PatternlibLanguagePicker {
  /**
   * Set the LanguagePicker event for other components to listen to the selected option item
   */
  lhSelect: EventEmitter<CustomEvent<IPatternlibLanguagePickerLhLanguageSelectEvent>>;
}


@ProxyCmp({
  inputs: ['flyoutPosition', 'options', 'selected', 'show', 'width']
})
@Component({
  selector: 'patternlib-language-picker-service',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['flyoutPosition', 'options', 'selected', 'show', 'width'],
})
export class PatternlibLanguagePickerService {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
    proxyOutputs(this, this.el, ['lhLanguageSelect']);
  }
}


import type { LhLanguageSelectEvent as IPatternlibLanguagePickerServiceLhLanguageSelectEvent } from '@liebherr/patternlib';

export declare interface PatternlibLanguagePickerService extends Components.PatternlibLanguagePickerService {
  /**
   * Set the LanguagePickerService event for other components to listen to the selected option item
   */
  lhLanguageSelect: EventEmitter<CustomEvent<IPatternlibLanguagePickerServiceLhLanguageSelectEvent>>;
}


@ProxyCmp({
  inputs: ['itemHeight', 'labelWidth', 'noSeparator', 'width']
})
@Component({
  selector: 'patternlib-list',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['itemHeight', 'labelWidth', 'noSeparator', 'width'],
})
export class PatternlibList {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


export declare interface PatternlibList extends Components.PatternlibList {}


@ProxyCmp({
  inputs: ['itemHeight', 'labelWidth']
})
@Component({
  selector: 'patternlib-list-head',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['itemHeight', 'labelWidth'],
})
export class PatternlibListHead {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


export declare interface PatternlibListHead extends Components.PatternlibListHead {}


@ProxyCmp({
  inputs: ['itemHeight', 'labelWidth', 'noSeparator']
})
@Component({
  selector: 'patternlib-list-item',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['itemHeight', 'labelWidth', 'noSeparator'],
})
export class PatternlibListItem {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


export declare interface PatternlibListItem extends Components.PatternlibListItem {}


@ProxyCmp({
  inputs: ['color', 'direction', 'duration', 'interval', 'name', 'orientation', 'progress', 'showLabel', 'width'],
  methods: ['start', 'reset']
})
@Component({
  selector: 'patternlib-loadingbar',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['color', 'direction', 'duration', 'interval', 'name', 'orientation', 'progress', 'showLabel', 'width'],
})
export class PatternlibLoadingbar {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
    proxyOutputs(this, this.el, ['lhLoadingComplete', 'lhAnimationComplete', 'lhProgressChange']);
  }
}


import type { lhLoadingComplete as IPatternlibLoadingbarlhLoadingComplete } from '@liebherr/patternlib';
import type { LhAnimationComplete as IPatternlibLoadingbarLhAnimationComplete } from '@liebherr/patternlib';

export declare interface PatternlibLoadingbar extends Components.PatternlibLoadingbar {
  /**
   * Provide a method to get triggered each time after the loading bar completed loading.
   */
  lhLoadingComplete: EventEmitter<CustomEvent<IPatternlibLoadingbarlhLoadingComplete>>;
  /**
   *  @deprecated Provide a method to get triggered each time after the loading bar finished loading.
   */
  lhAnimationComplete: EventEmitter<CustomEvent<IPatternlibLoadingbarLhAnimationComplete>>;
  /**
   * Event emitted on progress change.
   */
  lhProgressChange: EventEmitter<CustomEvent<number>>;
}


@ProxyCmp({
  methods: ['deactivateItems', 'getItemBySubid']
})
@Component({
  selector: 'patternlib-main-navigation',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: [],
})
export class PatternlibMainNavigation {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
    proxyOutputs(this, this.el, ['lhHeaderComponentRegister']);
  }
}


export declare interface PatternlibMainNavigation extends Components.PatternlibMainNavigation {
  /**
   * Component registers itself at the parent component on load
   */
  lhHeaderComponentRegister: EventEmitter<CustomEvent<string>>;
}


@ProxyCmp({
  inputs: ['badge', 'dot', 'isActive', 'subid', 'submenuActive']
})
@Component({
  selector: 'patternlib-main-navigation-item',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['badge', 'dot', 'isActive', 'subid', 'submenuActive'],
})
export class PatternlibMainNavigationItem {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
    proxyOutputs(this, this.el, ['lhMainNavigationComponentRegister', 'lhMainNavigationItemToggle', 'lhMobileNavigationClicked']);
  }
}


import type { LhMainNavigationToggled as IPatternlibMainNavigationItemLhMainNavigationToggled } from '@liebherr/patternlib';

export declare interface PatternlibMainNavigationItem extends Components.PatternlibMainNavigationItem {
  /**
   * Component registers itself at the parent component on load
   */
  lhMainNavigationComponentRegister: EventEmitter<CustomEvent<void>>;
  /**
   * Event is emitted when sub navigation should be displayed
   */
  lhMainNavigationItemToggle: EventEmitter<CustomEvent<IPatternlibMainNavigationItemLhMainNavigationToggled>>;
  /**
   * Event is emitted in mobile mode on click
   */
  lhMobileNavigationClicked: EventEmitter<CustomEvent<number>>;
}


@ProxyCmp({
  inputs: ['apiKey', 'centerLat', 'centerLng', 'circles', 'extraMapOptions', 'extraMapStyle', 'gpxTracks', 'height', 'initialZoomLevel', 'markers', 'polygons', 'tracks', 'useDefaultMapStyle'],
  methods: ['drawMarker', 'drawPolygon', 'drawCircle', 'drawTrack']
})
@Component({
  selector: 'patternlib-mapview',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['apiKey', 'centerLat', 'centerLng', 'circles', 'extraMapOptions', 'extraMapStyle', 'gpxTracks', 'height', 'initialZoomLevel', 'markers', 'polygons', 'tracks', 'useDefaultMapStyle'],
})
export class PatternlibMapview {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
    proxyOutputs(this, this.el, ['lhMapLoaded']);
  }
}


export declare interface PatternlibMapview extends Components.PatternlibMapview {
  /**
   * Event that is triggered when map is loaded
   */
  lhMapLoaded: EventEmitter<CustomEvent<boolean>>;
}


@ProxyCmp({
})
@Component({
  selector: 'patternlib-meta-navigation',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: [],
})
export class PatternlibMetaNavigation {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


export declare interface PatternlibMetaNavigation extends Components.PatternlibMetaNavigation {}


@ProxyCmp({
  inputs: ['active']
})
@Component({
  selector: 'patternlib-meta-navigation-item',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['active'],
})
export class PatternlibMetaNavigationItem {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


export declare interface PatternlibMetaNavigationItem extends Components.PatternlibMetaNavigationItem {}


@ProxyCmp({
  inputs: ['allowCloseOnBackdrop', 'backgroundColor', 'cancelButtonDisabled', 'cancelButtonWidth', 'cancelIconName', 'cancelIconPosition', 'cancelLabel', 'cancelType', 'confirmButtonDisabled', 'confirmButtonWidth', 'confirmIconName', 'confirmIconPosition', 'confirmLabel', 'confirmType', 'fullWidthButtons', 'height', 'hideCancel', 'hideConfirm', 'hideSubmit', 'iconName', 'iconPosition', 'iconSize', 'imgPosition', 'labelSize', 'marginTop', 'maxHeight', 'modalTitle', 'show', 'showIcon', 'width'],
  methods: ['setScreenSize']
})
@Component({
  selector: 'patternlib-modal',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['allowCloseOnBackdrop', 'backgroundColor', 'cancelButtonDisabled', 'cancelButtonWidth', 'cancelIconName', 'cancelIconPosition', 'cancelLabel', 'cancelType', 'confirmButtonDisabled', 'confirmButtonWidth', 'confirmIconName', 'confirmIconPosition', 'confirmLabel', 'confirmType', 'fullWidthButtons', 'height', 'hideCancel', 'hideConfirm', 'hideSubmit', 'iconName', 'iconPosition', 'iconSize', 'imgPosition', 'labelSize', 'marginTop', 'maxHeight', 'modalTitle', 'show', 'showIcon', 'width'],
})
export class PatternlibModal {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
    proxyOutputs(this, this.el, ['lhClose', 'lhConfirm', 'lhCancel']);
  }
}


import type { LhClose as IPatternlibModalLhClose } from '@liebherr/patternlib';
import type { LhModalConfirm as IPatternlibModalLhModalConfirm } from '@liebherr/patternlib';
import type { LhModalCancel as IPatternlibModalLhModalCancel } from '@liebherr/patternlib';

export declare interface PatternlibModal extends Components.PatternlibModal {
  /**
   * Provide a method to be triggered if the modal is closed
   */
  lhClose: EventEmitter<CustomEvent<IPatternlibModalLhClose>>;
  /**
   * Provide a method to be triggered if the modal is confirmed
   */
  lhConfirm: EventEmitter<CustomEvent<IPatternlibModalLhModalConfirm>>;
  /**
   * Provide a method to be triggered if the modal is canceled
   */
  lhCancel: EventEmitter<CustomEvent<IPatternlibModalLhModalCancel>>;
}


@ProxyCmp({
  inputs: ['allowCloseOnBackdrop', 'backdropColor', 'contentWidth', 'show', 'showCloseIcon']
})
@Component({
  selector: 'patternlib-modal-base',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['allowCloseOnBackdrop', 'backdropColor', 'contentWidth', 'show', 'showCloseIcon'],
})
export class PatternlibModalBase {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
    proxyOutputs(this, this.el, ['lhClose']);
  }
}


import type { LhClose as IPatternlibModalBaseLhClose } from '@liebherr/patternlib';

export declare interface PatternlibModalBase extends Components.PatternlibModalBase {
  /**
   * Provide a method to be triggered if the modal is closed
   */
  lhClose: EventEmitter<CustomEvent<IPatternlibModalBaseLhClose>>;
}


@ProxyCmp({
  inputs: ['display', 'iconName']
})
@Component({
  selector: 'patternlib-multicolor-icon',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['display', 'iconName'],
})
export class PatternlibMulticolorIcon {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


export declare interface PatternlibMulticolorIcon extends Components.PatternlibMulticolorIcon {}


@ProxyCmp({
  inputs: ['additionalInfo', 'additionalInfoPosition', 'applyButtonText', 'closeOnScroll', 'controlled', 'deselectAllText', 'disabled', 'display', 'errorText', 'filterable', 'hideApply', 'hideSelectAllButton', 'label', 'name', 'placeholder', 'placeholderText', 'preventInput', 'selectAllText', 'selectedOptionsLength', 'size', 'status', 'successText', 'textinputWidth', 'usePlaceholderHeight', 'value', 'warningText', 'width'],
  methods: ['setFocus', 'setBlur']
})
@Component({
  selector: 'patternlib-multiselect',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['additionalInfo', 'additionalInfoPosition', 'applyButtonText', 'closeOnScroll', 'controlled', 'deselectAllText', 'disabled', 'display', 'errorText', 'filterable', 'hideApply', 'hideSelectAllButton', 'label', 'name', 'placeholder', 'placeholderText', 'preventInput', 'selectAllText', 'selectedOptionsLength', 'size', 'status', 'successText', 'textinputWidth', 'usePlaceholderHeight', 'value', 'warningText', 'width'],
})
export class PatternlibMultiselect {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
    proxyOutputs(this, this.el, ['lhSelect', 'lhChange', 'lhMultiselectClose', 'lhOpen']);
  }
}


import type { LhMultipleOptionSelectEvent as IPatternlibMultiselectLhMultipleOptionSelectEvent } from '@liebherr/patternlib';
import type { LhChange as IPatternlibMultiselectLhChange } from '@liebherr/patternlib';
import type { LhMultiselectClose as IPatternlibMultiselectLhMultiselectClose } from '@liebherr/patternlib';

export declare interface PatternlibMultiselect extends Components.PatternlibMultiselect {
  /**
   * Emits an object containing all "selected" options and the currently "updated" (removed) options.
selected =>  No delta value, but all selected options.
updated => Only a delta update of options which have been removed.
   */
  lhSelect: EventEmitter<CustomEvent<IPatternlibMultiselectLhMultipleOptionSelectEvent>>;
  /**
   *  @deprecated Provide a method to get triggered each time the input value has changed.
   */
  lhChange: EventEmitter<CustomEvent<IPatternlibMultiselectLhChange>>;
  /**
   * Provides an event that is emitted each time the dropdown flyout is closed.
Contains a flag if the apply button click caused the close to apply the temporary selection.
This event is only emitted with controlled behavior.
   */
  lhMultiselectClose: EventEmitter<CustomEvent<IPatternlibMultiselectLhMultiselectClose>>;
  /**
   * Provides an event that is emitted each time the dropdown flyout is opened.
This event is only emitted with controlled behavior. See our "controlled with apply button" demo on how to use.
   */
  lhOpen: EventEmitter<CustomEvent<void>>;
}


@ProxyCmp({
  inputs: ['hoverTimeout'],
  methods: ['closePreviousSubmenu', 'open', 'close']
})
@Component({
  selector: 'patternlib-navigation-flyout',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['hoverTimeout'],
})
export class PatternlibNavigationFlyout {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
    proxyOutputs(this, this.el, ['lhHeaderComponentRegister', 'lhFlyoutNavigationUpdated', 'lhFlyoutNavigationClosed']);
  }
}


export declare interface PatternlibNavigationFlyout extends Components.PatternlibNavigationFlyout {
  /**
   * register the element at it's parent element by type
   */
  lhHeaderComponentRegister: EventEmitter<CustomEvent<string>>;
  /**
   * if flyout navigation is open this event is emitted in didUpdate lifecycle hook
   */
  lhFlyoutNavigationUpdated: EventEmitter<CustomEvent<{ height: number; currentLevel: number }>>;

  lhFlyoutNavigationClosed: EventEmitter<CustomEvent<void>>;
}


@ProxyCmp({
  methods: ['open', 'close', 'navigateTo']
})
@Component({
  selector: 'patternlib-navigation-flyout-base',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: [],
})
export class PatternlibNavigationFlyoutBase {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
    proxyOutputs(this, this.el, ['lhHeaderComponentRegister', 'lhFlyoutNavigationClosed']);
  }
}


export declare interface PatternlibNavigationFlyoutBase extends Components.PatternlibNavigationFlyoutBase {
  /**
   * register the element at it's parent element by type
   */
  lhHeaderComponentRegister: EventEmitter<CustomEvent<string>>;
  /**
   * Event that is fired when the flyout navigation is closed
   */
  lhFlyoutNavigationClosed: EventEmitter<CustomEvent<void>>;
}


@ProxyCmp({
})
@Component({
  selector: 'patternlib-navigation-flyout-base-group',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: [],
})
export class PatternlibNavigationFlyoutBaseGroup {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


export declare interface PatternlibNavigationFlyoutBaseGroup extends Components.PatternlibNavigationFlyoutBaseGroup {}


@ProxyCmp({
  inputs: ['hasSubitems', 'isBackButton', 'isHeadingItem']
})
@Component({
  selector: 'patternlib-navigation-flyout-base-item',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['hasSubitems', 'isBackButton', 'isHeadingItem'],
})
export class PatternlibNavigationFlyoutBaseItem {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


export declare interface PatternlibNavigationFlyoutBaseItem extends Components.PatternlibNavigationFlyoutBaseItem {}


@ProxyCmp({
  inputs: ['isBackButton', 'isOpen']
})
@Component({
  selector: 'patternlib-navigation-flyout-item',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['isBackButton', 'isOpen'],
})
export class PatternlibNavigationFlyoutItem {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
    proxyOutputs(this, this.el, ['lhFlyoutNavigationEntered', 'lhFlyoutNavigationLeft', 'lhMobileNavigationClicked', 'lhFlyoutNavigationBackClicked', 'lhFlyoutNavigationItemUpdated', 'lhFlyoutNavigationDesktopUpdated']);
  }
}


import type { LhFlyoutNavigationEntered as IPatternlibNavigationFlyoutItemLhFlyoutNavigationEntered } from '@liebherr/patternlib';

export declare interface PatternlibNavigationFlyoutItem extends Components.PatternlibNavigationFlyoutItem {
  /**
   * Event is emitted after entering a menu bullet
   */
  lhFlyoutNavigationEntered: EventEmitter<CustomEvent<IPatternlibNavigationFlyoutItemLhFlyoutNavigationEntered>>;
  /**
   * Event is emitted after leaving a menu bullet
   */
  lhFlyoutNavigationLeft: EventEmitter<CustomEvent<void>>;
  /**
   * Event is emitted on click to item, as event detail the direction of menu level change is given +1 or -1
   */
  lhMobileNavigationClicked: EventEmitter<CustomEvent<number>>;
  /**
   * Event is emitted on click to back button on mobile screens
   */
  lhFlyoutNavigationBackClicked: EventEmitter<CustomEvent<number>>;
  /**
   * Event is emitted after the navigation has been updated on mobile screens, as event detail the height of the current item is given
   */
  lhFlyoutNavigationItemUpdated: EventEmitter<CustomEvent<number>>;
  /**
   * Event is emitted after the navigation has been updated on desktop screens, as event detail the height of the submenu set is given
   */
  lhFlyoutNavigationDesktopUpdated: EventEmitter<CustomEvent<number>>;
}


@ProxyCmp({
  inputs: ['height', 'scrollablefitcontent', 'useFlyoutGroups', 'width'],
  methods: ['closeFlyout']
})
@Component({
  selector: 'patternlib-notification-flyout',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['height', 'scrollablefitcontent', 'useFlyoutGroups', 'width'],
})
export class PatternlibNotificationFlyout {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
    proxyOutputs(this, this.el, ['lhScroll']);
  }
}


export declare interface PatternlibNotificationFlyout extends Components.PatternlibNotificationFlyout {
  /**
   * Emittet if the flyout-items container is scrolled.
   */
  lhScroll: EventEmitter<CustomEvent<any>>;
}


@ProxyCmp({
  inputs: ['accessToken', 'baseUrl', 'environment', 'height', 'httpErrorCode', 'width']
})
@Component({
  selector: 'patternlib-notification-flyout-service',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['accessToken', 'baseUrl', 'environment', 'height', 'httpErrorCode', 'width'],
})
export class PatternlibNotificationFlyoutService {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
    proxyOutputs(this, this.el, ['lhUnseenNotificationCountChange']);
  }
}


import type { LhUnseenNotificationCountChange as IPatternlibNotificationFlyoutServiceLhUnseenNotificationCountChange } from '@liebherr/patternlib';

export declare interface PatternlibNotificationFlyoutService extends Components.PatternlibNotificationFlyoutService {
  /**
   * Event that is fired when the unseenNotificationCount is changing
   */
  lhUnseenNotificationCountChange: EventEmitter<CustomEvent<IPatternlibNotificationFlyoutServiceLhUnseenNotificationCountChange>>;
}


@ProxyCmp({
  inputs: ['isImportant', 'viewed']
})
@Component({
  selector: 'patternlib-notification-item',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['isImportant', 'viewed'],
})
export class PatternlibNotificationItem {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


export declare interface PatternlibNotificationItem extends Components.PatternlibNotificationItem {}


@ProxyCmp({
  inputs: ['disabled', 'focused', 'hidden', 'label', 'selected', 'size', 'value']
})
@Component({
  selector: 'patternlib-option',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['disabled', 'focused', 'hidden', 'label', 'selected', 'size', 'value'],
})
export class PatternlibOption {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
    proxyOutputs(this, this.el, ['lhOptionSelect']);
  }
}


import type { LhInternalOptionSelect as IPatternlibOptionLhInternalOptionSelect } from '@liebherr/patternlib';

export declare interface PatternlibOption extends Components.PatternlibOption {
  /**
   * Emits an LhOptionSelect on click.
   */
  lhOptionSelect: EventEmitter<CustomEvent<IPatternlibOptionLhInternalOptionSelect>>;
}


@ProxyCmp({
  inputs: ['label']
})
@Component({
  selector: 'patternlib-option-header',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['label'],
})
export class PatternlibOptionHeader {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


export declare interface PatternlibOptionHeader extends Components.PatternlibOptionHeader {}


@ProxyCmp({
  inputs: ['absolutePositionOnMobileDevices', 'alignment', 'centerOnMobileBreakpoint', 'closeOnScroll', 'contentWidth', 'disableClickHandlers', 'disabled', 'enableContentClickEventPropagation', 'fit', 'groupName', 'offsetBottomY', 'offsetLeftX', 'offsetRightX', 'offsetTopY', 'position', 'restrictMaxHeight', 'show', 'showArrow', 'target', 'useAbsolutePositioning', 'useFlyoutGroups', 'variant', 'width'],
  methods: ['openFlyout', 'closeFlyout', 'updateFlyout', 'closeFlyoutmenu']
})
@Component({
  selector: 'patternlib-overlay-container',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['absolutePositionOnMobileDevices', 'alignment', 'centerOnMobileBreakpoint', 'closeOnScroll', 'contentWidth', 'disableClickHandlers', 'disabled', 'enableContentClickEventPropagation', 'fit', 'groupName', 'offsetBottomY', 'offsetLeftX', 'offsetRightX', 'offsetTopY', 'position', 'restrictMaxHeight', 'show', 'showArrow', 'target', 'useAbsolutePositioning', 'useFlyoutGroups', 'variant', 'width'],
})
export class PatternlibOverlayContainer {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
    proxyOutputs(this, this.el, ['lhOpen', 'lhClose']);
  }
}


import type { LhOpen as IPatternlibOverlayContainerLhOpen } from '@liebherr/patternlib';
import type { LhClose as IPatternlibOverlayContainerLhClose } from '@liebherr/patternlib';

export declare interface PatternlibOverlayContainer extends Components.PatternlibOverlayContainer {
  /**
   * Triggers when the flyout is opened.
Set bubbles to false to prevent other components to receive that lhOpen-Event (unwanted side-effects).
   */
  lhOpen: EventEmitter<CustomEvent<IPatternlibOverlayContainerLhOpen>>;
  /**
   * Triggers when the flyout is closed.
   */
  lhClose: EventEmitter<CustomEvent<IPatternlibOverlayContainerLhClose>>;
}


@ProxyCmp({
  inputs: ['anchorIsDeactivated', 'baseUrl', 'baseUrlTransformer', 'currentPage', 'lastPage'],
  methods: ['getCurrentPage', 'getLastPage']
})
@Component({
  selector: 'patternlib-pagination',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['anchorIsDeactivated', 'baseUrl', 'baseUrlTransformer', 'currentPage', 'lastPage'],
})
export class PatternlibPagination {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
    proxyOutputs(this, this.el, ['lhButtonFirst', 'lhButtonPrev', 'lhButtonNext', 'lhButtonLast', 'lhChangeToPage', 'lhChange']);
  }
}


import type { LhChangeToPage as IPatternlibPaginationLhChangeToPage } from '@liebherr/patternlib';
import type { LhChange as IPatternlibPaginationLhChange } from '@liebherr/patternlib';

export declare interface PatternlibPagination extends Components.PatternlibPagination {
  /**
   * Emitted when the arrow-first-page button is clicked.
   */
  lhButtonFirst: EventEmitter<CustomEvent<void>>;
  /**
   * Emitted when the arrow left button is clicked.
   */
  lhButtonPrev: EventEmitter<CustomEvent<void>>;
  /**
   * Emitted when the arrow right button is clicked.
   */
  lhButtonNext: EventEmitter<CustomEvent<void>>;
  /**
   * Emitted when the arrow-last-page button is clicked.
   */
  lhButtonLast: EventEmitter<CustomEvent<void>>;
  /**
   * Emitted when a page item is clicked (returns page number).
   */
  lhChangeToPage: EventEmitter<CustomEvent<IPatternlibPaginationLhChangeToPage>>;
  /**
   * Generic event fired on every page change. Value is the number (one indexed) of the new page.
   */
  lhChange: EventEmitter<CustomEvent<IPatternlibPaginationLhChange>>;
}


@ProxyCmp({
  inputs: ['active', 'anchorIsDeactivated', 'href', 'label']
})
@Component({
  selector: 'patternlib-pagination-item',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['active', 'anchorIsDeactivated', 'href', 'label'],
})
export class PatternlibPaginationItem {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
    proxyOutputs(this, this.el, ['lhPaginationItemClicked']);
  }
}


import type { LhChangeToPage as IPatternlibPaginationItemLhChangeToPage } from '@liebherr/patternlib';

export declare interface PatternlibPaginationItem extends Components.PatternlibPaginationItem {
  /**
   * Emitted if the step item is activated.
   */
  lhPaginationItemClicked: EventEmitter<CustomEvent<IPatternlibPaginationItemLhChangeToPage>>;
}


@ProxyCmp({
})
@Component({
  selector: 'patternlib-pictogram-navigation',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: [],
})
export class PatternlibPictogramNavigation {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


export declare interface PatternlibPictogramNavigation extends Components.PatternlibPictogramNavigation {}


@ProxyCmp({
  inputs: ['active', 'iconName', 'label']
})
@Component({
  selector: 'patternlib-pictogram-navigation-item',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['active', 'iconName', 'label'],
})
export class PatternlibPictogramNavigationItem {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


export declare interface PatternlibPictogramNavigationItem extends Components.PatternlibPictogramNavigationItem {}


@ProxyCmp({
  inputs: ['color', 'deleteIcon', 'disabled', 'errorStatus', 'height', 'label', 'maxWidth', 'noStates', 'pillIcon', 'selected', 'size', 'theme', 'type']
})
@Component({
  selector: 'patternlib-pill',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['color', 'deleteIcon', 'disabled', 'errorStatus', 'height', 'label', 'maxWidth', 'noStates', 'pillIcon', 'selected', 'size', 'theme', 'type'],
})
export class PatternlibPill {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
    proxyOutputs(this, this.el, ['lhClick', 'lhClose']);
  }
}


import type { LhPillClick as IPatternlibPillLhPillClick } from '@liebherr/patternlib';
import type { LhClose as IPatternlibPillLhClose } from '@liebherr/patternlib';

export declare interface PatternlibPill extends Components.PatternlibPill {
  /**
   * Provide a method to be triggered each time the pill is clicked.
   */
  lhClick: EventEmitter<CustomEvent<IPatternlibPillLhPillClick>>;
  /**
   * Provide a method to be triggered each time the delete Icon is clicked.
   */
  lhClose: EventEmitter<CustomEvent<IPatternlibPillLhClose>>;
}


@ProxyCmp({
  inputs: ['active', 'disabled', 'size', 'type']
})
@Component({
  selector: 'patternlib-pin',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['active', 'disabled', 'size', 'type'],
})
export class PatternlibPin {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


export declare interface PatternlibPin extends Components.PatternlibPin {}


@ProxyCmp({
  inputs: ['amount', 'size', 'type']
})
@Component({
  selector: 'patternlib-pricing',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['amount', 'size', 'type'],
})
export class PatternlibPricing {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


export declare interface PatternlibPricing extends Components.PatternlibPricing {}


@ProxyCmp({
  inputs: ['color', 'direction', 'duration', 'interval', 'name', 'orientation', 'progress', 'textmessageColor', 'width'],
  methods: ['start', 'reset']
})
@Component({
  selector: 'patternlib-progressbar',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['color', 'direction', 'duration', 'interval', 'name', 'orientation', 'progress', 'textmessageColor', 'width'],
})
export class PatternlibProgressbar {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


export declare interface PatternlibProgressbar extends Components.PatternlibProgressbar {}


@ProxyCmp({
  inputs: ['iconSize', 'moduleBackground', 'quoteCaption', 'quoteText', 'showQuoteIcon']
})
@Component({
  selector: 'patternlib-quote',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['iconSize', 'moduleBackground', 'quoteCaption', 'quoteText', 'showQuoteIcon'],
})
export class PatternlibQuote {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


export declare interface PatternlibQuote extends Components.PatternlibQuote {}


@ProxyCmp({
  inputs: ['controlled', 'gap', 'gridWrap', 'horizontal', 'itemsMinWidth', 'name', 'status', 'value', 'width']
})
@Component({
  selector: 'patternlib-radiobutton',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['controlled', 'gap', 'gridWrap', 'horizontal', 'itemsMinWidth', 'name', 'status', 'value', 'width'],
})
export class PatternlibRadiobutton {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
    proxyOutputs(this, this.el, ['lhChange']);
  }
}


import type { LhChange as IPatternlibRadiobuttonLhChange } from '@liebherr/patternlib';

export declare interface PatternlibRadiobutton extends Components.PatternlibRadiobutton {
  /**
   * Provide a method to be triggered each time a radio button item is clicked.
   */
  lhChange: EventEmitter<CustomEvent<IPatternlibRadiobuttonLhChange>>;
}


@ProxyCmp({
  inputs: ['checked', 'color', 'disabled', 'isInTable', 'label', 'name', 'status', 'value'],
  methods: ['setFocus', 'setBlur']
})
@Component({
  selector: 'patternlib-radiobutton-item',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['checked', 'color', 'disabled', 'isInTable', 'label', 'name', 'status', 'value'],
})
export class PatternlibRadiobuttonItem {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
    proxyOutputs(this, this.el, ['lhRadiobuttonSelection']);
  }
}


export declare interface PatternlibRadiobuttonItem extends Components.PatternlibRadiobuttonItem {
  /**
   * Provide a method to be triggered each time a radio button item is clicked.
   */
  lhRadiobuttonSelection: EventEmitter<CustomEvent<string>>;
}


@ProxyCmp({
  inputs: ['buttonOutside', 'controlled', 'disabled', 'errorText', 'label', 'name', 'placeholder', 'readonly', 'showRemoveIcon', 'size', 'status', 'type', 'value', 'width'],
  methods: ['setFocus', 'setBlur']
})
@Component({
  selector: 'patternlib-searchbox',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['buttonOutside', 'controlled', 'disabled', 'errorText', 'label', 'name', 'placeholder', 'readonly', 'showRemoveIcon', 'size', 'status', 'type', 'value', 'width'],
})
export class PatternlibSearchbox {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
    proxyOutputs(this, this.el, ['lhSearchChange', 'lhChange', 'lhEnterPress', 'lhSearch', 'lhClear']);
  }
}


import type { LhSearch as IPatternlibSearchboxLhSearch } from '@liebherr/patternlib';
import type { LhChange as IPatternlibSearchboxLhChange } from '@liebherr/patternlib';

export declare interface PatternlibSearchbox extends Components.PatternlibSearchbox {
  /**
   *  @deprecated Use 'lhChange" instead. Bewar: lhChange returns an object.
   */
  lhSearchChange: EventEmitter<CustomEvent<IPatternlibSearchboxLhSearch>>;
  /**
   * Provide a method to get the searchbox value when the value is changed.
   */
  lhChange: EventEmitter<CustomEvent<IPatternlibSearchboxLhChange>>;
  /**
   * Provide a method to get the searchbox value when the Enter key get pressed.
   */
  lhEnterPress: EventEmitter<CustomEvent<IPatternlibSearchboxLhSearch>>;
  /**
   * Provide a method to get the searchbox value when the search icon get clicked.
   */
  lhSearch: EventEmitter<CustomEvent<IPatternlibSearchboxLhSearch>>;
  /**
   * Emitted when the search input was cleared.
   */
  lhClear: EventEmitter<CustomEvent<void>>;
}


@ProxyCmp({
  inputs: ['checked', 'disabled', 'horizontal', 'itemsMinWidth', 'type', 'value'],
  methods: ['setFocus', 'setBlur']
})
@Component({
  selector: 'patternlib-selection-card',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['checked', 'disabled', 'horizontal', 'itemsMinWidth', 'type', 'value'],
})
export class PatternlibSelectionCard {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
    proxyOutputs(this, this.el, ['lhCardSelection', 'lhChange']);
  }
}


import type { LhChange as IPatternlibSelectionCardLhChange } from '@liebherr/patternlib';

export declare interface PatternlibSelectionCard extends Components.PatternlibSelectionCard {
  /**
   * Provide a method to be triggered each time a selection card is clicked.
   */
  lhCardSelection: EventEmitter<CustomEvent<number | string>>;
  /**
   * Provide a method to be triggered each time the checkbox is clicked.
   */
  lhChange: EventEmitter<CustomEvent<IPatternlibSelectionCardLhChange>>;
}


@ProxyCmp({
  inputs: ['controlled', 'fill', 'gap', 'gridWrap', 'horizontal', 'itemsMinWidth', 'name', 'type', 'value', 'width']
})
@Component({
  selector: 'patternlib-selection-card-group',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['controlled', 'fill', 'gap', 'gridWrap', 'horizontal', 'itemsMinWidth', 'name', 'type', 'value', 'width'],
})
export class PatternlibSelectionCardGroup {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
    proxyOutputs(this, this.el, ['lhSelect']);
  }
}


import type { LhCardOptionSelectEvent as IPatternlibSelectionCardGroupLhCardOptionSelectEvent } from '@liebherr/patternlib';

export declare interface PatternlibSelectionCardGroup extends Components.PatternlibSelectionCardGroup {
  /**
   * Set the Card group event for other components to listen to the selected item.
   */
  lhSelect: EventEmitter<CustomEvent<IPatternlibSelectionCardGroupLhCardOptionSelectEvent>>;
}


@ProxyCmp({
  inputs: ['collapsed', 'userInfo', 'userName', 'width']
})
@Component({
  selector: 'patternlib-sidebar',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['collapsed', 'userInfo', 'userName', 'width'],
})
export class PatternlibSidebar {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
    proxyOutputs(this, this.el, ['lhCollapse']);
  }
}


import type { LhCollapseClick as IPatternlibSidebarLhCollapseClick } from '@liebherr/patternlib';

export declare interface PatternlibSidebar extends Components.PatternlibSidebar {
  /**
   * Provide a method to be triggered each time the Sidebar is collapsed/expanded.
   */
  lhCollapse: EventEmitter<CustomEvent<IPatternlibSidebarLhCollapseClick>>;
}


@ProxyCmp({
  inputs: ['active', 'childNodeActive', 'disabled', 'href', 'iconBold', 'iconName', 'isCollapsed', 'isScrollingEnds', 'itemId', 'label', 'mainNodeActive', 'scrollOffset', 'showFlyout', 'subitemsAreCollapsed', 'target', 'width']
})
@Component({
  selector: 'patternlib-sidebar-item',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['active', 'childNodeActive', 'disabled', 'href', 'iconBold', 'iconName', 'isCollapsed', 'isScrollingEnds', 'itemId', 'label', 'mainNodeActive', 'scrollOffset', 'showFlyout', 'subitemsAreCollapsed', 'target', 'width'],
})
export class PatternlibSidebarItem {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
    proxyOutputs(this, this.el, ['lhItemActivation', 'lhSidebarUnselectAllOther']);
  }
}


import type { LhSidebarItemActivation as IPatternlibSidebarItemLhSidebarItemActivation } from '@liebherr/patternlib';
import type { LhSidebarItem as IPatternlibSidebarItemLhSidebarItem } from '@liebherr/patternlib';

export declare interface PatternlibSidebarItem extends Components.PatternlibSidebarItem {
  /**
   * Emitted if the sidebar item is activated.
   */
  lhItemActivation: EventEmitter<CustomEvent<IPatternlibSidebarItemLhSidebarItemActivation>>;
  /**
   * Emitted if the sidebar get set to active.
   */
  lhSidebarUnselectAllOther: EventEmitter<CustomEvent<IPatternlibSidebarItemLhSidebarItem>>;
}


@ProxyCmp({
  inputs: ['backLabel', 'headerId', 'noAnimation', 'overlayId', 'show'],
  methods: ['showOverlayFromHeader', 'showOverlayFromBody']
})
@Component({
  selector: 'patternlib-sidebar-overlay',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['backLabel', 'headerId', 'noAnimation', 'overlayId', 'show'],
})
export class PatternlibSidebarOverlay {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
    proxyOutputs(this, this.el, ['lhHeaderComponentRegister', 'lhClose']);
  }
}


import type { LhClose as IPatternlibSidebarOverlayLhClose } from '@liebherr/patternlib';

export declare interface PatternlibSidebarOverlay extends Components.PatternlibSidebarOverlay {

  lhHeaderComponentRegister: EventEmitter<CustomEvent<string>>;
  /**
   * Provide a method to be triggered if the sidebar-overlay is closed
   */
  lhClose: EventEmitter<CustomEvent<IPatternlibSidebarOverlayLhClose>>;
}


@ProxyCmp({
  inputs: ['height', 'radius', 'start', 'type', 'width']
})
@Component({
  selector: 'patternlib-skeletonloader',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['height', 'radius', 'start', 'type', 'width'],
})
export class PatternlibSkeletonloader {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


export declare interface PatternlibSkeletonloader extends Components.PatternlibSkeletonloader {}


@ProxyCmp({
  inputs: ['additionalInfo', 'additionalInfoPosition', 'controlled', 'cursor', 'decimalSeparator', 'errorText', 'infoText', 'interactionMode', 'label', 'max', 'min', 'name', 'rangeSelection', 'roundDecimalPlaces', 'showStepDots', 'showStepExtendedButton', 'status', 'step', 'successText', 'usePlaceholderHeight', 'value', 'valueMax', 'valueMin', 'warningText']
})
@Component({
  selector: 'patternlib-slider',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['additionalInfo', 'additionalInfoPosition', 'controlled', 'cursor', 'decimalSeparator', 'errorText', 'infoText', 'interactionMode', 'label', 'max', 'min', 'name', 'rangeSelection', 'roundDecimalPlaces', 'showStepDots', 'showStepExtendedButton', 'status', 'step', 'successText', 'usePlaceholderHeight', 'value', 'valueMax', 'valueMin', 'warningText'],
})
export class PatternlibSlider {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
    proxyOutputs(this, this.el, ['lhInputStart', 'lhInputEnd', 'lhChange', 'lhStatusChange']);
  }
}


import type { LhInputStartEnd as IPatternlibSliderLhInputStartEnd } from '@liebherr/patternlib';
import type { LhChange as IPatternlibSliderLhChange } from '@liebherr/patternlib';
import type { LhStatusChange as IPatternlibSliderLhStatusChange } from '@liebherr/patternlib';

export declare interface PatternlibSlider extends Components.PatternlibSlider {
  /**
   * Provide a method to get triggered each time the user starts changing the value
   */
  lhInputStart: EventEmitter<CustomEvent<IPatternlibSliderLhInputStartEnd>>;
  /**
   * Provide a method to get triggered each time the user finishes changing the value (mouseUp)
   */
  lhInputEnd: EventEmitter<CustomEvent<IPatternlibSliderLhInputStartEnd>>;
  /**
   * Provide a method to get triggered each time the value has changed
   */
  lhChange: EventEmitter<CustomEvent<IPatternlibSliderLhChange>>;
  /**
   * Provide a method to get triggered each time the status has changed
   */
  lhStatusChange: EventEmitter<CustomEvent<IPatternlibSliderLhStatusChange>>;
}


@ProxyCmp({
  inputs: ['isCollapsed', 'labelLeft', 'labelRight']
})
@Component({
  selector: 'patternlib-slidercontrol',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['isCollapsed', 'labelLeft', 'labelRight'],
})
export class PatternlibSlidercontrol {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


export declare interface PatternlibSlidercontrol extends Components.PatternlibSlidercontrol {}


@ProxyCmp({
  inputs: ['duration', 'progress', 'size', 'spin', 'type', 'variant'],
  methods: ['start', 'reset']
})
@Component({
  selector: 'patternlib-spinner',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['duration', 'progress', 'size', 'spin', 'type', 'variant'],
})
export class PatternlibSpinner {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
    proxyOutputs(this, this.el, ['lhAnimationComplete']);
  }
}


import type { LhAnimationComplete as IPatternlibSpinnerLhAnimationComplete } from '@liebherr/patternlib';

export declare interface PatternlibSpinner extends Components.PatternlibSpinner {
  /**
   * Provide a method to get triggered each time after the determinate spinner finished loading.
   */
  lhAnimationComplete: EventEmitter<CustomEvent<IPatternlibSpinnerLhAnimationComplete>>;
}


@ProxyCmp({
  inputs: ['barPercentage', 'data', 'dataLabelFontSize', 'headlineFontSize', 'labelDirection', 'labelFontSize', 'legendPosition', 'showDataLabels', 'showLegend', 'showTooltips', 'subheadlineFontSize', 'unit']
})
@Component({
  selector: 'patternlib-stacked-bar-chart',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['barPercentage', 'data', 'dataLabelFontSize', 'headlineFontSize', 'labelDirection', 'labelFontSize', 'legendPosition', 'showDataLabels', 'showLegend', 'showTooltips', 'subheadlineFontSize', 'unit'],
})
export class PatternlibStackedBarChart {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


export declare interface PatternlibStackedBarChart extends Components.PatternlibStackedBarChart {}


@ProxyCmp({
  inputs: ['color', 'size', 'state']
})
@Component({
  selector: 'patternlib-status-message',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['color', 'size', 'state'],
})
export class PatternlibStatusMessage {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


export declare interface PatternlibStatusMessage extends Components.PatternlibStatusMessage {}


@ProxyCmp({
  inputs: ['label', 'type']
})
@Component({
  selector: 'patternlib-status-pill',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['label', 'type'],
})
export class PatternlibStatusPill {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


export declare interface PatternlibStatusPill extends Components.PatternlibStatusPill {}


@ProxyCmp({
  methods: ['setActivateItem']
})
@Component({
  selector: 'patternlib-steps',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: [],
})
export class PatternlibSteps {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
    proxyOutputs(this, this.el, ['lhChangeItem']);
  }
}


import type { LhChangeItem as IPatternlibStepsLhChangeItem } from '@liebherr/patternlib';

export declare interface PatternlibSteps extends Components.PatternlibSteps {
  /**
   * Provide a method to be triggered each time a step item is clicked.
   */
  lhChangeItem: EventEmitter<CustomEvent<IPatternlibStepsLhChangeItem>>;
}


@ProxyCmp({
  inputs: ['valueCurrent', 'valueMax'],
  methods: ['setValues']
})
@Component({
  selector: 'patternlib-steps-counter',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['valueCurrent', 'valueMax'],
})
export class PatternlibStepsCounter {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


export declare interface PatternlibStepsCounter extends Components.PatternlibStepsCounter {}


@ProxyCmp({
  inputs: ['active', 'disabled', 'itemId', 'status', 'type'],
  methods: ['setActiveState']
})
@Component({
  selector: 'patternlib-steps-item',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['active', 'disabled', 'itemId', 'status', 'type'],
})
export class PatternlibStepsItem {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
    proxyOutputs(this, this.el, ['lhItemActivation']);
  }
}


import type { LhTabsItemActivation as IPatternlibStepsItemLhTabsItemActivation } from '@liebherr/patternlib';

export declare interface PatternlibStepsItem extends Components.PatternlibStepsItem {
  /**
   * Emitted if the step item is activated.
   */
  lhItemActivation: EventEmitter<CustomEvent<IPatternlibStepsItemLhTabsItemActivation>>;
}


@ProxyCmp({
  methods: ['triggerAnimation']
})
@Component({
  selector: 'patternlib-sticky-sidebar',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: [],
})
export class PatternlibStickySidebar {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


export declare interface PatternlibStickySidebar extends Components.PatternlibStickySidebar {}


@ProxyCmp({
  inputs: ['badgeValue', 'href', 'iconBold', 'iconName', 'includeSidebarSelector', 'isActive', 'label', 'target', 'tooltippCloseDelay'],
  methods: ['triggerTooltipp']
})
@Component({
  selector: 'patternlib-sticky-sidebar-item',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['badgeValue', 'href', 'iconBold', 'iconName', 'includeSidebarSelector', 'isActive', 'label', 'target', 'tooltippCloseDelay'],
})
export class PatternlibStickySidebarItem {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


export declare interface PatternlibStickySidebarItem extends Components.PatternlibStickySidebarItem {}


@ProxyCmp({
  inputs: ['containerWidth', 'direction', 'width'],
  methods: ['updateStorytabs', 'setStorytabsItemToActive']
})
@Component({
  selector: 'patternlib-storytabs',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['containerWidth', 'direction', 'width'],
})
export class PatternlibStorytabs {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
    proxyOutputs(this, this.el, ['lhChangeItem']);
  }
}


import type { LhChangeItem as IPatternlibStorytabsLhChangeItem } from '@liebherr/patternlib';

export declare interface PatternlibStorytabs extends Components.PatternlibStorytabs {
  /**
   * Provide a method to be triggered each time a StorytabsItem is clicked
   */
  lhChangeItem: EventEmitter<CustomEvent<IPatternlibStorytabsLhChangeItem>>;
}


@ProxyCmp({
  inputs: ['active', 'disabled', 'error', 'itemId', 'label', 'success']
})
@Component({
  selector: 'patternlib-storytabs-item',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['active', 'disabled', 'error', 'itemId', 'label', 'success'],
})
export class PatternlibStorytabsItem {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
    proxyOutputs(this, this.el, ['lhStorytabsItemLabelChange', 'lhStorytabsItemDisabledChange', 'lhStorytabsItemSuccessChange', 'lhStorytabsItemErrorChange']);
  }
}


import type { LhLabelChange as IPatternlibStorytabsItemLhLabelChange } from '@liebherr/patternlib';
import type { LhDisabledChange as IPatternlibStorytabsItemLhDisabledChange } from '@liebherr/patternlib';
import type { LhSuccessChange as IPatternlibStorytabsItemLhSuccessChange } from '@liebherr/patternlib';
import type { LhErrorChange as IPatternlibStorytabsItemLhErrorChange } from '@liebherr/patternlib';

export declare interface PatternlibStorytabsItem extends Components.PatternlibStorytabsItem {
  /**
   * Provide a method to be triggered each time the label property change, to communicate the change to its parent
   */
  lhStorytabsItemLabelChange: EventEmitter<CustomEvent<IPatternlibStorytabsItemLhLabelChange>>;
  /**
   * Provide a method to be triggered each time the disabled property change, to communicate the change to its parent
   */
  lhStorytabsItemDisabledChange: EventEmitter<CustomEvent<IPatternlibStorytabsItemLhDisabledChange>>;
  /**
   * Provide a method to be triggered each time the success property change, to communicate the change to its parent
   */
  lhStorytabsItemSuccessChange: EventEmitter<CustomEvent<IPatternlibStorytabsItemLhSuccessChange>>;
  /**
   * Provide a method to be triggered each time the success property change, to communicate the change to its parent
   */
  lhStorytabsItemErrorChange: EventEmitter<CustomEvent<IPatternlibStorytabsItemLhErrorChange>>;
}


@ProxyCmp({
  inputs: ['actions', 'columns', 'dense', 'disabledRows', 'dropdownLabel', 'firstColumnMinWidth', 'forceMobileSize', 'header', 'implicitIds', 'lastColumnMinWidth', 'maxTableHeight', 'multiSelect', 'noDataLabel', 'noDataLabelWidth', 'noGridLines', 'noTableBorder', 'page', 'pagination', 'preventLoading', 'rowsPerPage', 'sectionHeader', 'serverSide', 'singleSelect', 'sortingMenuIcon', 'totalRows', 'width'],
  methods: ['updateTable', 'resetSelection', 'setScreenSize', 'startLoading', 'goToPage']
})
@Component({
  selector: 'patternlib-table',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['actions', 'columns', 'dense', 'disabledRows', 'dropdownLabel', 'firstColumnMinWidth', 'forceMobileSize', 'header', 'implicitIds', 'lastColumnMinWidth', 'maxTableHeight', 'multiSelect', 'noDataLabel', 'noDataLabelWidth', 'noGridLines', 'noTableBorder', 'page', 'pagination', 'preventLoading', 'rowsPerPage', 'sectionHeader', 'serverSide', 'singleSelect', 'sortingMenuIcon', 'totalRows', 'width'],
})
export class PatternlibTable {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
    proxyOutputs(this, this.el, ['lhRowClick', 'lhRowEnter', 'lhRowLeave', 'lhActionClick', 'lhRowSelect', 'lhPageChange', 'lhFilterChange', 'lhSortingChange']);
  }
}


import type { LhRowClick as IPatternlibTableLhRowClick } from '@liebherr/patternlib';
import type { LhRowEnter as IPatternlibTableLhRowEnter } from '@liebherr/patternlib';
import type { LhRowLeave as IPatternlibTableLhRowLeave } from '@liebherr/patternlib';
import type { LhTableActionClick as IPatternlibTableLhTableActionClick } from '@liebherr/patternlib';
import type { LhRowSelect as IPatternlibTableLhRowSelect } from '@liebherr/patternlib';
import type { LhTablePageChange as IPatternlibTableLhTablePageChange } from '@liebherr/patternlib';
import type { LhTableFilterChange as IPatternlibTableLhTableFilterChange } from '@liebherr/patternlib';
import type { LhTableSortingChange as IPatternlibTableLhTableSortingChange } from '@liebherr/patternlib';

export declare interface PatternlibTable extends Components.PatternlibTable {
  /**
   * Provide a method to be triggered each time a row is clicked
   */
  lhRowClick: EventEmitter<CustomEvent<IPatternlibTableLhRowClick>>;
  /**
   * Provide a method to be triggered each time a row is entered.
   */
  lhRowEnter: EventEmitter<CustomEvent<IPatternlibTableLhRowEnter>>;
  /**
   * Provide a method to be triggered each time a row is left.
   */
  lhRowLeave: EventEmitter<CustomEvent<IPatternlibTableLhRowLeave>>;
  /**
   * Provide a method to be triggered each time an action is clicked
   */
  lhActionClick: EventEmitter<CustomEvent<IPatternlibTableLhTableActionClick>>;
  /**
   * Provide a method to be triggered each time a checkbox is clicked
   */
  lhRowSelect: EventEmitter<CustomEvent<IPatternlibTableLhRowSelect>>;
  /**
   * Provide a method to be triggered each time the page number changes (server side mode)
   */
  lhPageChange: EventEmitter<CustomEvent<IPatternlibTableLhTablePageChange>>;
  /**
   * Provide a method to be triggered each time a filter input changes (server side mode)
   */
  lhFilterChange: EventEmitter<CustomEvent<IPatternlibTableLhTableFilterChange>>;
  /**
   * Provide a method to be triggered each time a column get sorted (server side mode)
   */
  lhSortingChange: EventEmitter<CustomEvent<IPatternlibTableLhTableSortingChange>>;
}


@ProxyCmp({
})
@Component({
  selector: 'patternlib-table-base',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: [],
})
export class PatternlibTableBase {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


export declare interface PatternlibTableBase extends Components.PatternlibTableBase {}


@ProxyCmp({
  inputs: ['colspan', 'noBorder', 'noPadding', 'width']
})
@Component({
  selector: 'patternlib-table-base-cell',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['colspan', 'noBorder', 'noPadding', 'width'],
})
export class PatternlibTableBaseCell {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


export declare interface PatternlibTableBaseCell extends Components.PatternlibTableBaseCell {}


@ProxyCmp({
  inputs: ['active', 'disabled', 'noBorder', 'showSubRows']
})
@Component({
  selector: 'patternlib-table-base-row',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['active', 'disabled', 'noBorder', 'showSubRows'],
})
export class PatternlibTableBaseRow {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


export declare interface PatternlibTableBaseRow extends Components.PatternlibTableBaseRow {}


@ProxyCmp({
  inputs: ['cellId', 'padding', 'rowId', 'value']
})
@Component({
  selector: 'patternlib-table-cell',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['cellId', 'padding', 'rowId', 'value'],
})
export class PatternlibTableCell {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


export declare interface PatternlibTableCell extends Components.PatternlibTableCell {}


@ProxyCmp({
})
@Component({
  selector: 'patternlib-table-head',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: [],
})
export class PatternlibTableHead {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


export declare interface PatternlibTableHead extends Components.PatternlibTableHead {}


@ProxyCmp({
  inputs: ['align', 'bold', 'label', 'sorting']
})
@Component({
  selector: 'patternlib-table-head-column',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['align', 'bold', 'label', 'sorting'],
})
export class PatternlibTableHeadColumn {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
    proxyOutputs(this, this.el, ['lhPatternlibTableHeadColumnLabelChanged']);
  }
}


export declare interface PatternlibTableHeadColumn extends Components.PatternlibTableHeadColumn {

  lhPatternlibTableHeadColumnLabelChanged: EventEmitter<CustomEvent<any>>;
}


@ProxyCmp({
  inputs: ['align', 'label']
})
@Component({
  selector: 'patternlib-table-head-section',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['align', 'label'],
})
export class PatternlibTableHeadSection {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


export declare interface PatternlibTableHeadSection extends Components.PatternlibTableHeadSection {}


@ProxyCmp({
  inputs: ['controlled', 'titleName']
})
@Component({
  selector: 'patternlib-table-of-contents',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['controlled', 'titleName'],
})
export class PatternlibTableOfContents {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
    proxyOutputs(this, this.el, ['lhChange']);
  }
}


export declare interface PatternlibTableOfContents extends Components.PatternlibTableOfContents {

  lhChange: EventEmitter<CustomEvent<{ id: string; targetSelector: string }>>;
}


@ProxyCmp({
  inputs: ['current', 'identifier', 'subChapter', 'targetSelector', 'titleName']
})
@Component({
  selector: 'patternlib-table-of-contents-chapter',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['current', 'identifier', 'subChapter', 'targetSelector', 'titleName'],
})
export class PatternlibTableOfContentsChapter {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
    proxyOutputs(this, this.el, ['__LhInternalChapterClicked']);
  }
}


import type { ChapterClickEvent as IPatternlibTableOfContentsChapterChapterClickEvent } from '@liebherr/patternlib';

export declare interface PatternlibTableOfContentsChapter extends Components.PatternlibTableOfContentsChapter {

  __LhInternalChapterClicked: EventEmitter<CustomEvent<IPatternlibTableOfContentsChapterChapterClickEvent>>;
}


@ProxyCmp({
  inputs: ['state']
})
@Component({
  selector: 'patternlib-table-sort-arrows',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['state'],
})
export class PatternlibTableSortArrows {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


export declare interface PatternlibTableSortArrows extends Components.PatternlibTableSortArrows {}


@ProxyCmp({
  inputs: ['alignItems', 'controlled', 'customHeight', 'noOverflow', 'noOverflowShadow', 'paddingTop', 'size', 'subtle'],
  methods: ['setTabToActive']
})
@Component({
  selector: 'patternlib-tabs',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['alignItems', 'controlled', 'customHeight', 'noOverflow', 'noOverflowShadow', 'paddingTop', 'size', 'subtle'],
})
export class PatternlibTabs {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
    proxyOutputs(this, this.el, ['lhChangeItem', 'lhChange']);
  }
}


import type { LhChangeItem as IPatternlibTabsLhChangeItem } from '@liebherr/patternlib';
import type { LhChange as IPatternlibTabsLhChange } from '@liebherr/patternlib';

export declare interface PatternlibTabs extends Components.PatternlibTabs {
  /**
   *  @deprecated Use lhChange.
Provide a method to be triggered each time a tab is clicked.
   */
  lhChangeItem: EventEmitter<CustomEvent<IPatternlibTabsLhChangeItem>>;
  /**
   * Get the id (or index) of the activated tab item.
   */
  lhChange: EventEmitter<CustomEvent<IPatternlibTabsLhChange>>;
}


@ProxyCmp({
  inputs: ['active', 'badge', 'capitalize', 'disabled', 'itemId', 'label', 'show', 'subitems', 'subitemsAreCollapsed', 'subtle']
})
@Component({
  selector: 'patternlib-tabs-item',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['active', 'badge', 'capitalize', 'disabled', 'itemId', 'label', 'show', 'subitems', 'subitemsAreCollapsed', 'subtle'],
})
export class PatternlibTabsItem {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
    proxyOutputs(this, this.el, ['lhItemActivation']);
  }
}


import type { LhTabsItemActivation as IPatternlibTabsItemLhTabsItemActivation } from '@liebherr/patternlib';

export declare interface PatternlibTabsItem extends Components.PatternlibTabsItem {
  /**
   * Emitted if the tab item is activated.
   */
  lhItemActivation: EventEmitter<CustomEvent<IPatternlibTabsItemLhTabsItemActivation>>;
}


@ProxyCmp({
  inputs: ['headline', 'image', 'imageObjectFit', 'text']
})
@Component({
  selector: 'patternlib-teaser',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['headline', 'image', 'imageObjectFit', 'text'],
})
export class PatternlibTeaser {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


export declare interface PatternlibTeaser extends Components.PatternlibTeaser {}


@ProxyCmp({
  inputs: ['additionalInfo', 'additionalInfoPosition', 'controlled', 'disabled', 'display', 'errorText', 'height', 'infoText', 'label', 'maxlength', 'name', 'placeholder', 'readonly', 'status', 'successText', 'usePlaceholderHeight', 'value', 'warningText', 'width'],
  methods: ['setFocus', 'setBlur']
})
@Component({
  selector: 'patternlib-textarea',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['additionalInfo', 'additionalInfoPosition', 'controlled', 'disabled', 'display', 'errorText', 'height', 'infoText', 'label', 'maxlength', 'name', 'placeholder', 'readonly', 'status', 'successText', 'usePlaceholderHeight', 'value', 'warningText', 'width'],
})
export class PatternlibTextarea {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
    proxyOutputs(this, this.el, ['lhChange', 'lhBlur']);
  }
}


import type { LhChange as IPatternlibTextareaLhChange } from '@liebherr/patternlib';
import type { LhBlur as IPatternlibTextareaLhBlur } from '@liebherr/patternlib';

export declare interface PatternlibTextarea extends Components.PatternlibTextarea {
  /**
   * Provide a method to get triggered each time the value has changed
   */
  lhChange: EventEmitter<CustomEvent<IPatternlibTextareaLhChange>>;
  /**
   * Provide a method to get triggered each time the element has lost focus
   */
  lhBlur: EventEmitter<CustomEvent<IPatternlibTextareaLhBlur>>;
}


@ProxyCmp({
  inputs: ['additionalInfo', 'additionalInfoPosition', 'controlled', 'disabled', 'display', 'errorText', 'infoText', 'label', 'max', 'maxlength', 'min', 'name', 'placeholder', 'readonly', 'readonlyNoStyle', 'showCopyIcon', 'showRemoveIcon', 'size', 'status', 'step', 'successText', 'type', 'usePlaceholderHeight', 'value', 'warningText', 'width'],
  methods: ['setFocus', 'setBlur']
})
@Component({
  selector: 'patternlib-textinput',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['additionalInfo', 'additionalInfoPosition', 'controlled', 'disabled', 'display', 'errorText', 'infoText', 'label', 'max', 'maxlength', 'min', 'name', 'placeholder', 'readonly', 'readonlyNoStyle', 'showCopyIcon', 'showRemoveIcon', 'size', 'status', 'step', 'successText', 'type', 'usePlaceholderHeight', 'value', 'warningText', 'width'],
})
export class PatternlibTextinput {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
    proxyOutputs(this, this.el, ['lhChange', 'lhBlur', 'lhCopyValue']);
  }
}


import type { LhChange as IPatternlibTextinputLhChange } from '@liebherr/patternlib';
import type { LhBlur as IPatternlibTextinputLhBlur } from '@liebherr/patternlib';
import type { LhCopyValue as IPatternlibTextinputLhCopyValue } from '@liebherr/patternlib';

export declare interface PatternlibTextinput extends Components.PatternlibTextinput {
  /**
   * Provide a method to get triggered each time the value has changed
   */
  lhChange: EventEmitter<CustomEvent<IPatternlibTextinputLhChange>>;
  /**
   * Provide a method to get triggered each time the element has lost focus
   */
  lhBlur: EventEmitter<CustomEvent<IPatternlibTextinputLhBlur>>;
  /**
   * Provide a method to be triggered if the copy button gets clicked
   */
  lhCopyValue: EventEmitter<CustomEvent<IPatternlibTextinputLhCopyValue>>;
}


@ProxyCmp({
  inputs: ['bold', 'disabled', 'hasAnchor', 'hovered', 'href', 'iconPosition', 'label', 'size', 'target', 'uppercase', 'variant', 'width']
})
@Component({
  selector: 'patternlib-textlink',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['bold', 'disabled', 'hasAnchor', 'hovered', 'href', 'iconPosition', 'label', 'size', 'target', 'uppercase', 'variant', 'width'],
})
export class PatternlibTextlink {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


export declare interface PatternlibTextlink extends Components.PatternlibTextlink {}


@ProxyCmp({
  inputs: ['additionalInfo', 'additionalInfoPosition', 'controlled', 'disabled', 'errorText', 'label', 'name', 'size', 'status', 'successText', 'usePlaceholderHeight', 'value', 'warningText']
})
@Component({
  selector: 'patternlib-texttoggle',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['additionalInfo', 'additionalInfoPosition', 'controlled', 'disabled', 'errorText', 'label', 'name', 'size', 'status', 'successText', 'usePlaceholderHeight', 'value', 'warningText'],
})
export class PatternlibTexttoggle {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
    proxyOutputs(this, this.el, ['lhChange']);
  }
}


import type { LhChange as IPatternlibTexttoggleLhChange } from '@liebherr/patternlib';

export declare interface PatternlibTexttoggle extends Components.PatternlibTexttoggle {
  /**
   * Provide a method to be triggered each time a TexttoggleItem is clicked.
   */
  lhChange: EventEmitter<CustomEvent<IPatternlibTexttoggleLhChange>>;
}


@ProxyCmp({
  inputs: ['active', 'disabled', 'label', 'size', 'value', 'width']
})
@Component({
  selector: 'patternlib-texttoggle-item',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['active', 'disabled', 'label', 'size', 'value', 'width'],
})
export class PatternlibTexttoggleItem {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
    proxyOutputs(this, this.el, ['lhItemSelect', 'lhItemBlur', 'lhItemKeyDown']);
  }
}


export declare interface PatternlibTexttoggleItem extends Components.PatternlibTexttoggleItem {
  /**
   * Internal event used to inform the texttoggle about selection.
   */
  lhItemSelect: EventEmitter<CustomEvent<string>>;
  /**
   * Internal event used inform the texttoggle about blur.
   */
  lhItemBlur: EventEmitter<CustomEvent<string>>;
  /**
   * Internal event used inform the texttoggle about keydown.
   */
  lhItemKeyDown: EventEmitter<CustomEvent<string>>;
}


@ProxyCmp({
  inputs: ['backgroundColor', 'mode', 'theme']
})
@Component({
  selector: 'patternlib-theme',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['backgroundColor', 'mode', 'theme'],
})
export class PatternlibTheme {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


export declare interface PatternlibTheme extends Components.PatternlibTheme {}


@ProxyCmp({
  inputs: ['position', 'width'],
  methods: ['createToastItem']
})
@Component({
  selector: 'patternlib-toast',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['position', 'width'],
})
export class PatternlibToast {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
    proxyOutputs(this, this.el, ['lhClose', 'lhUndo']);
  }
}


import type { LhToastClose as IPatternlibToastLhToastClose } from '@liebherr/patternlib';
import type { LhToastUndo as IPatternlibToastLhToastUndo } from '@liebherr/patternlib';

export declare interface PatternlibToast extends Components.PatternlibToast {
  /**
   * A event that signals a closed toast item.
   */
  lhClose: EventEmitter<CustomEvent<IPatternlibToastLhToastClose>>;
  /**
   * A event that signals a click onto the Undo-Icon.
   */
  lhUndo: EventEmitter<CustomEvent<IPatternlibToastLhToastUndo>>;
}


@ProxyCmp({
  inputs: ['animationValue', 'autoHide', 'delay', 'height', 'itemId', 'message', 'position', 'show', 'showIcon', 'showUndo', 'subline', 'type', 'undoLabel', 'width']
})
@Component({
  selector: 'patternlib-toast-item',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['animationValue', 'autoHide', 'delay', 'height', 'itemId', 'message', 'position', 'show', 'showIcon', 'showUndo', 'subline', 'type', 'undoLabel', 'width'],
})
export class PatternlibToastItem {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
    proxyOutputs(this, this.el, ['lhToastItemClose', 'lhToastItemUndoClick', 'lhToastItemRendered']);
  }
}


import type { LhToastClose as IPatternlibToastItemLhToastClose } from '@liebherr/patternlib';
import type { LhToastUndo as IPatternlibToastItemLhToastUndo } from '@liebherr/patternlib';

export declare interface PatternlibToastItem extends Components.PatternlibToastItem {
  /**
   * Provide a method to be triggered if the toast gets closed
   */
  lhToastItemClose: EventEmitter<CustomEvent<IPatternlibToastItemLhToastClose>>;
  /**
   * Provide a method to be triggered if the undo button gets clicked
   */
  lhToastItemUndoClick: EventEmitter<CustomEvent<IPatternlibToastItemLhToastUndo>>;
  /**
   * Provide a method to be triggered when the toast item is rendered
   */
  lhToastItemRendered: EventEmitter<CustomEvent<any>>;
}


@ProxyCmp({
  inputs: ['additionalInfo', 'additionalInfoPosition', 'checked', 'controlled', 'disabled', 'errorText', 'label', 'labelOff', 'labelOn', 'name', 'status', 'successText', 'usePlaceholderHeight', 'warningText'],
  methods: ['setFocus', 'setBlur']
})
@Component({
  selector: 'patternlib-toggle',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['additionalInfo', 'additionalInfoPosition', 'checked', 'controlled', 'disabled', 'errorText', 'label', 'labelOff', 'labelOn', 'name', 'status', 'successText', 'usePlaceholderHeight', 'warningText'],
})
export class PatternlibToggle {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
    proxyOutputs(this, this.el, ['lhChange']);
  }
}


import type { LhChange as IPatternlibToggleLhChange } from '@liebherr/patternlib';

export declare interface PatternlibToggle extends Components.PatternlibToggle {
  /**
   * Provide a method to be triggered each time the Toogle is clicked.
   */
  lhChange: EventEmitter<CustomEvent<IPatternlibToggleLhChange>>;
}


@ProxyCmp({
  inputs: ['delay', 'restrictMaxHeight', 'show', 'tooltipAlignment', 'tooltipPosition', 'useAbsolutePositioning', 'variant', 'width'],
  methods: ['closeTooltip']
})
@Component({
  selector: 'patternlib-tooltip',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['delay', 'restrictMaxHeight', 'show', 'tooltipAlignment', 'tooltipPosition', 'useAbsolutePositioning', 'variant', 'width'],
})
export class PatternlibTooltip {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


export declare interface PatternlibTooltip extends Components.PatternlibTooltip {}


@ProxyCmp({
  inputs: ['dense', 'disabled', 'isOpen', 'itemId', 'noArrow']
})
@Component({
  selector: 'patternlib-tree-item',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['dense', 'disabled', 'isOpen', 'itemId', 'noArrow'],
})
export class PatternlibTreeItem {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
    proxyOutputs(this, this.el, ['lhTreeExpand']);
  }
}


import type { LhClick as IPatternlibTreeItemLhClick } from '@liebherr/patternlib';

export declare interface PatternlibTreeItem extends Components.PatternlibTreeItem {
  /**
   * Triggers when the arrow icon is clicked.
   */
  lhTreeExpand: EventEmitter<CustomEvent<IPatternlibTreeItemLhClick>>;
}


